const messages = {
  es: {
    translations: {
      titles: {
        home: 'Home',
        resources: 'Recursos',
        teaching: 'Enseñanza',
        support: 'Soporte',
        language: 'Idioma',
        contents: 'Contenido',
        integration: 'Integración',
        contact: 'Contacto',
        compliance: 'Compliance',
        signup: 'Registrarse',
        signupSuccess: 'Inscripción Realizada',
        signin: 'Iniciar sesión',
        login: 'Inicio de sesión',
        finalizeAccount: 'Complete su registro',
        guardianData: 'Datos del Tutor Legal',
        forgotPassword: 'Olvide mi contraseña',
        searchResults: 'Resultados de la búsqueda',
        pageNotFound: 'Página no encontrada',
        adjustImage: 'Ajusta tu foto',
        account: 'Perfil',
        admin: 'Admin',
        help: 'Ayuda',
        rate: 'Evaluar',
        rated: 'Evaluado',
        rateQuestion: '¿Qué te pareció este contenido?',
        profileData: 'Datos personales',
        permissions: 'Notificaciones y permisos',
        plan: 'Plan',
        config: 'Configuración',
        mouse: 'Ratón',
        keyboard: 'Teclado',
        trackpad: 'Panel Táctil',
        organs: 'Cuerpos y Sistemas',
        completeAnatomy: 'Anatomía\nCompleta',
        topographicAnatomy: 'Anatomía\nTopográfica',
        systemicAnatomy: 'Anatomía\nSistémica',
        cellStructure: 'Células y tejidos',
        cytology: 'Citología',
        histology: 'Histología',
        histopathology: 'Histopatología',
        development: 'Funciones corporales y desarrollo',
        embryology: 'Embriología',
        physiology: 'Fisiología',
        specialties: 'Clínica integrada',
        radiology: 'Radiología',
        pathology: 'Patología',
        api: 'API BioAtlas',
        institutions: 'Instituciones',
        whiteLabel: 'White Label',
        VR: 'Realidad Virtual 3D',
        multiplatform: 'Multiplataforma',
        animations: 'Animaciones interactivas en 3D',
        accessControl: 'Control de acceso',
        languages: 'Disponible en 3 idiomas',
        platform:
          'Transforma la manera en que tu institución enseña ciencias de la salud.',
        modules:
          'Varios módulos de Enseñanza para la Salud en una sola plataforma',
        cadaver: 'Cadáver Virtual',
        cadaver3D: 'Cádaver Virtual 3D',
        atlas3D: 'Atlas Anatómico 3D',
        blades: 'Láminas Histológicas y Histopatológicas',
        cardiacCycle: 'Ciclo cardíaco del corazón',
        fiberContraction: 'Contracción de la fibra muscular',
        potentialGeneration: 'Generación y conducción del potencial de acción',
        hematosis: 'Hematosis',
        synapticTransmission: 'Transmisión sináptica',
        lungVentilation: 'Ventilación pulmonar',
        pathophysiology: 'Fisiopatologia',
        'pathologicalConditions.1': 'Acné',
        'pathologicalConditions.2': 'Afecciones pleurales',
        'pathologicalConditions.3': 'Anemia falciforme',
        'pathologicalConditions.4': 'Asma',
        'pathologicalConditions.5': 'Cardiopatía isquémica',
        'pathologicalConditions.6': 'Desviaciones de la columna vertebral',
        'pathologicalConditions.7': 'Diabetes mellitus tipo 1',
        'pathologicalConditions.8': 'Diabetes mellitus tipo 2',
        'pathologicalConditions.9': 'Distensión muscular',
        'pathologicalConditions.10': 'Enfermedad de Graves',
        'pathologicalConditions.11': 'Enfermedad ulcerosa péptica',
        'pathologicalConditions.12': 'Gastritis',
        'pathologicalConditions.13': 'Fracturas óseas',
        'pathologicalConditions.14': 'Neumonía',
        'pathologicalConditions.15': 'Síndrome de ovario poliquístico',
        'pathologicalConditions.16': 'Sinusitis',
        'pathologicalConditions.17': 'Tiroiditis de Hashimoto',
        'pathologicalConditions.18': 'Trombosis',
        'pathologicalConditions.19': 'Tromboembolismo pulmonar',
        'pathologicalConditions.20': 'Tuberculosis',
        'pathologicalConditions.21': 'Urticaria',
        'histopathology.1': 'Enfermedades del sistema respiratorio',
        'histopathology.2': 'Enfermedades del sistema cardiovascular',
        'histopathology.3': 'Enfermedades del sistema digestivo',
        'histopathology.4': 'Trastornos de la circulación sanguínea',
        'histopathology.5': 'Tumor',
        'histopathology.6': 'Enfermedades del sistema nervioso',
        'histopathology.7': 'Enfermedades del sistema genital',
        'histopathology.8': 'Enfermedades del sistema urogenital',
        'histopathology.9': 'Inflamación',
        'histopathology.10': 'Lesión y reparación de células y tejidos',
        'histopathology.11': 'Enfermedades del sistema endocrino',
        'histopathology.12': 'Enfermedades inmunológicas',
        'histopathology.13':
          'Enfermedades de los sistemas muscular y esquelético',
        'histopathology.14': 'Enfermedades del sistema hematopoyético',
        cardiology: 'Cardiologia / Urgencias cardíacas',
        firstAid: 'Primeros auxilios',
        pulmonology: 'Neumología',
        infectology: 'Infectología',
        neurology: 'Neurología',
        vascular: 'Vasculares',
        autoImmune: 'Reumatismo / Autoinmune',
        survey: 'Hola, ¿nos ayudan a mejorar BioAtlas?',
        collections: 'Colecciones',
        learningPaths: 'Trilhas',
        deleteCollections: 'Desea eliminar ',
        shareCollection: 'Compartir contenido para ',
        addToMyCollection: 'Añadir a mi colección',
        explore: 'Explorar',
        forTeachers: 'Para Profesores',
        forStudents: 'Para Alumnos',
        app: 'Aplicación',
        viewer3d: 'Visor 3D',
        slideViewer: 'Visor de láminas',
        radiologyViewer: 'Visor Radiología',
        biochemistry: 'Bioquímica',
        'features.collections': 'Compartición de Colecciones',
        'features.multiplatform': 'Multiplataforma',
        'features.laboratory': 'Reducción de Costos de Laboratorio',
        'features.support': 'Apoyo en Investigación y Estudios de Caso',
        'features.integration': 'Integración',
        'features.languages': 'Disponible en 3 Idiomas',
        pathologicalConditions: 'Pathological conditions',
        'radiology.1': 'Tomografías computarizadas',
        'radiology.2': 'Resonancias magnéticas',
        'radiology.3': 'Radiografías computarizadas',
        'radiology.4': 'Rayos X',
        'radiology.5': 'Ultrasonido',
        'cytology1.1': 'Virus',
        'cytology1.2': 'Célula Bacteriana',
        'cytology1.3': 'Célula Eucariota de Origen Animal',
        'cytology1.4': 'Célula del Sistema Inmunológico',
        'cytology1.5': 'Neurona',
        'cytology1.6': 'Célula Adiposa',
        'cytology1.7': 'Sistema ABO',
        'cytology1.8': 'Célula Sanguínea',
        'cytology1.9': 'Fibra Muscular',
        'cytology1.10': 'Islotes de Langerhans',
        'cytology1.11': 'Folículo Tiroideo',
        'cytology2.1': 'Difusión Simple',
        'cytology2.2': 'Difusión Facilitada',
        'cytology2.3': 'Bomba de Sodio y Potasio',
        'cytology2.4': 'Cotransporte',
        'cytology2.5': 'Contratransporte',
        integrations: 'Integraciones'
      },
      subtitles: {
        signup: 'Rellene la información para registrarse',
        validationSent: 'Información enviada por correo electrónico',
        signin: 'Inicie la sesión para acceder a su cuenta',
        finalizeAccount: 'Rellene el resto de la información',
        fillInfo: 'Complete la información a continuación:',
        resetPassword: 'Necesitas cambiar tu contraseña:',
        resetToken: 'Recibirás un token para cambiar tu contraseña',
        pageNotFound: 'Lo sentimos, hubo un error en nuestra página.',
        rightsReserved: 'Todos los derechos reservados.',
        aboutMedicalHarbour1:
          'BioAtlas es un producto de Medical Harbour, una empresa de tecnología que',
        aboutMedicalHarbour2:
          'desarrolla soluciones digitales para facilitar el aprendizaje en salud a través de contenidos interactivos y 3D.',
        aboutMedicalHarbour3:
          'Conozca nuestras soluciones para instituciones de Educación en Salud:',
        aboutMedicalHarbourDesktop1:
          'BioAtlas es un producto de Medical Harbour, una empresa de tecnología que desarrolla soluciones',
        aboutMedicalHarbourDesktop2:
          'digitales para facilitar el aprendizaje en salud a través de contenidos interactivos y 3D. Conozca nuestras',
        aboutMedicalHarbourDesktop3:
          'soluciones para instituciones de Educación en Salud:',
        tabText: 'Contenido Digital Interactivo para la Salud',
        group: 'Somos una empresa del Grupo Afya',
        sales: 'Póngase en contacto con nuestro equipo de ventas',
        detail: 'Informaciones',
        rotate: 'Girar',
        moreTools: 'Más herramientas',
        pin: 'Pin',
        ruler: 'Escala',
        arrow: 'Flecha',
        savePin: 'Guardar Pin',
        saveArrow: 'Guardar Flecha',
        saveRectangle: 'Guardar Rectángulo',
        fullscreen: 'Pantalla completa',
        info: 'Informaciones',
        move: 'Mover',
        select: 'Seleccionar',
        camera: 'Mover cámara',
        zoom: 'Zoom',
        resetZoom: 'Restablecer zoom',
        deselect: 'Eliminar selección',
        focus: 'Centrarse',
        selectMultiple: 'Seleccione varios',
        hide: 'Esconder',
        help: 'Ayuda',
        nextChapter: 'Próximo capítulo',
        previousChapter: 'Capítulo anterior',
        save: 'Guardar',
        saveNew: 'Guardar nuevo',
        animationPanel: 'Panel de animación',
        recentralize: 'Recentrar',
        undoAction: 'Deshacer acción',
        advanceAction: 'Rehacer acción',
        reset: 'Restablecer',
        playPause: 'Play/Pausa',
        restartAnimation: 'Reiniciar animación',
        speed: 'Velocidad',
        ClosePanelMinimize: 'Cerrar panel / Minimizar',
        basicTools: 'Herramientas básicas',
        animationControl: 'Control de animación',
        isolate: 'Isolar',
        tree: 'Árbol de anatomía',
        textbox: 'Cuadro de texto',
        tag: 'Etiqueta',
        cutTool: 'Herramienta de recorte',
        turn: 'Voltear',
        menu: 'Menu',
        increaseZoom: 'Aumentar zoom',
        decreaseZoom: 'Disminuir zoom',
        originalZoom: 'Reposicionar',
        bladeMessage:
          'Para que funcionen los atajos de teclado, primero haga clic en la imagen y luego presione la tecla',
        organ: 'Organo',
        tissue: 'Tejido',
        color: 'Colorante',
        section: 'Sección',
        partners1: 'Únete a más de',
        partners2: 'instituciones educativas en',
        partners3: 'países de todo el mundo',
        completeAnatomy:
          'Ofrezca la base curricular definitiva en Anatomía Humana.',
        completeAnatomy2: `Acceda al <b>Cadáver Virtual</b> y al <b>Atlas 3D</b> para una navegación detallada. Este módulo integral cuenta con <b>más de 2.500 estructuras clasificadas</b>, organizadas en 12 sistemas y 9 regiones, disponibles en los modelos <b>Masculino y Femenino</b>. Garantice la <b>calidad y estandarización</b> de la enseñanza en todas las disciplinas de Ciencias de la Salud.`,
        completeAnatomy3:
          'La Anatomía Humana es la ciencia que estudia la morfología y la organización del cuerpo humano mediante la observación y el análisis de sus estructuras macroscópicas constitutivas. Este análisis está correlacionado con el funcionamiento de las distintas partes y los mecanismos de formación y respuesta a factores ambientales, genéticos y temporales. Puede clasificarse, a partir de la separación de las piezas, en Sistemas Orgánicos y Regiones Anatómicas. En este módulo se incluyeron modelos anatómicos representativos del cuerpo masculino y femenino, además del cadáver virtual masculino.',
        completeAnatomy4:
          'Cuenta con más de 2.500 estructuras etiquetadas de todos los sistemas anatómicos del cuerpo humano. Este módulo está dividido en modelos Masculino y Femenino y organizado según 12 sistemas anatómicos y 9 regiones.',
        completeAnatomy5:
          'Un cuerpo humano* real dividido en 1.878 cortes y fotografiado con equipo de altísima resolución, reconstruido digitalmente en 3D. El Cadáver Virtual conserva los colores, está segmentado y mapeado para una visualización completa.',
        topographicAnatomy: 'El Laboratorio de Anatomía del Futuro',
        topographicAnatomy2:
          'Transforme la Anatomía Topográfica en una experiencia interactiva y totalmente segura. Al dividir el cuerpo humano en regiones, facilitará al estudiante la comprensión de las relaciones anatómicas entre las estructuras de todos los sistemas en un segmento del cuerpo.',
        topographicAnatomy3:
          'La Anatomía Topográfica trata del estudio de la división del cuerpo humano en regiones, con el fin de facilitar la comprensión de las relaciones anatómicas entre las estructuras de todos los sistemas en un segmento determinado del cuerpo. Este método ayuda a dominar la topografía general de los órganos a partir de la percepción del funcionamiento y la ubicación de todas las piezas cercanas y relacionadas. En este módulo se incluyen las siguientes regiones anatómicas: Elementos Descriptivos del Cráneo, y las regiones anatómicas de la cabeza y el cuello, miembro superior derecho, miembro superior izquierdo, dorso, tórax, abdomen, pelvis, miembro inferior derecho y miembro inferior izquierdo.',
        systemicAnatomy: 'Visualización 3D Integral y Aprendizaje Activo',
        systemicAnatomy2:
          'Con nuestra tecnología 3D, los estudiantes exploran todos los sistemas (esquelético, muscular, nervioso, etc.) con claridad y precisión, optimizando el tiempo de estudio y mejorando la retención del contenido. Esta herramienta elimina la necesidad de gastos adicionales en piezas y modelos, garantizando la excelencia en la enseñanza sin sobrecargar el presupuesto de su institución.',
        systemicAnatomy3:
          'La Anatomía Sistémica aborda el estudio analítico de los sistemas orgánicos del cuerpo humano, estableciendo conjuntos de órganos y piezas anatómicas que desempeñan, de manera integrada, las mismas funciones en los mecanismos biológicos. Aunque cada sistema realiza una tarea distinta, todos están interconectados, garantizando el funcionamiento y la supervivencia del organismo como un todo. En este módulo se consideran los siguientes sistemas: Arterial, Articular, Digestivo, Endocrino, Esquelético, Linfático, Muscular, Nervioso, Respiratorio, Tegumentario, Urogenital y Venoso.',
        cytology: 'El Laboratorio Virtual que Optimiza Sus Costos',
        cytology2:
          'Garantice eficiencia y elimine los gastos recurrentes de laboratorio. El módulo de Citología permite explorar las estructuras celulares en detalle, con interactividad de vanguardia. Al tener acceso en línea, se elimina la necesidad de mantenimiento de microscopios, ofreciendo una herramienta de enseñanza activa que facilita el éxito del estudiante en el ciclo básico.',
        cytology3:
          'El módulo de Citología permite al usuario interactuar con dos categorías de contenidos 3D: Células y Membrana Celular. Explore las células:',
        cytology4:
          'Visualice un modelo 3D de la Membrana Celular y animaciones relacionadas con el transporte de moléculas a través de la membrana:',
        histology:
          'Reduzca los Costos de Mantenimiento y Ofrezca una Práctica Ilimitada',
        histology2:
          'El módulo de Histología funciona como un laboratorio virtual de microscopía completo, permitiendo explorar diversos tipos de tejidos, sistemas y órganos sensoriales con funciones de aumento digital e identificación de estructuras, eliminando los costos de láminas y equipos costosos.',
        histology3:
          'BioAtlas cuenta con un módulo dedicado al estudio de láminas, con más de 300 ejemplos de glándulas, órganos, tejidos y sistemas, además de láminas con patologías. También incluye una herramienta con funciones avanzadas para la visualización y el análisis de las mismas, con zoom de hasta 40x, anotaciones en las láminas, espejado, entre otras.',
        embryology: 'La Herramienta para Comprender el Desarrollo Embrionario',
        embryology2:
          'Brinde a sus estudiantes una visión completa e interactiva del desarrollo humano, desde la formación de los gametos hasta el embarazo y el estudio detallado de la placenta. Con recursos 3D inmersivos y contenidos que cubren cada etapa embrionaria y fetal, BioAtlas transforma disciplinas complejas en experiencias de aprendizaje accesibles, reduciendo los costos de laboratorio y fortaleciendo la calidad de la educación en salud de su institución.',
        embryology3:
          'Acompaña el desarrollo embrionario y fetal, desde la ovogénesis/espermatogénesis hasta el nacimiento, a través de animaciones interactivas en 3D del Período Embrionario del Desarrollo y del Período Fetal del Desarrollo.',
        physiology: 'Más Éxito para sus Estudiantes en Todos los Exámenes',
        physiology2:
          'El módulo de Fisiología detalla el funcionamiento del cuerpo humano y sus etapas de desarrollo, permitiéndole crear colecciones y estudios de caso de forma dinámica, preparando a los estudiantes para la práctica clínica y fortaleciendo la calidad de la enseñanza en su institución.',
        physiology3:
          'Explora el funcionamiento y las funciones normales del cuerpo humano a través de contenidos virtuales 3D interactivos:',
        radiology: 'Herramienta Esencial para el Razonamiento Diagnóstico',
        radiology2:
          'Prepare a sus estudiantes para la práctica clínica con el módulo de Radiología, que permite la visualización interactiva de tomografías, resonancias y radiografías, ofreciendo imágenes reales y la posibilidad de comparar exámenes. Promueva la integración de contenidos, transformando el aprendizaje en una experiencia activa y asegure que su institución ofrezca lo más avanzado en formación en salud.',
        radiology3:
          'Sistema para la visualización de imágenes DICOM con herramientas para la manipulación de estudios y casos clínicos radiológicos. Permite visualizar imágenes de diversas modalidades como:',
        pathology:
          'Desarrolle el Razonamiento Clínico y Epidemiológico de sus Estudiantes',
        pathology2:
          'El módulo de Patología, con láminas histopatológicas virtuales y modelos interactivos, facilita el estudio de diversas alteraciones morfológicas y funcionales, además de preparar a sus estudiantes para la práctica clínica. Asegure que su institución promueva el desarrollo del razonamiento clínico-epidemiológico.',
        pathology3:
          'Este módulo incluye animaciones tridimensionales que representan procesos fisiológicos no saludables (patológicos), destacando las alteraciones que ocurren en el cuerpo en estas condiciones.',
        features:
          '¡Explore los detalles del Cuerpo Humano en cualquier momento y lugar!',
        VR: 'Involucrar a estudiantes y profesores a través del entorno inmersivo de Realidad Virtual',
        multiplatform:
          'Acceso a través de cualquier navegador web, aplicación de Android o iOS',
        animations:
          'Diversos contenidos con animaciones 3D guiadas para facilitar la comprensión',
        accessControl:
          'Habilite, controle y analice el acceso de profesores y alumnos',
        integration:
          'Integre nuestro contenido en su página web a través de nuestra API',
        languages:
          'Contenido mapeado y traducido en portugués, español e inglés',
        testimonial0_0:
          'BioAtlas es una excelente herramienta para que el estudiante integre los diferentes contenidos de las ciencias biológicas y de la salud',
        testimonial0_1: 'Profesor de Fisiología Humana y Neurociencia en FMIT',
        newsletter:
          'Hable con nuestro equipo y explore BioAtlas, diseñado para apoyar e innovar en las instituciones médicas.',
        platform:
          'BioAtlas reúne en una sola plataforma anatomía humana en 3D, laboratorios virtuales, herramientas de enseñanza colaborativa y otros contenidos interactivos para ofrecer una experiencia de aprendizaje en salud inmersiva y eficiente.',
        modules:
          'Un entorno virtual con miles de posibilidades. Contenidos relacionados con la enseñanza de la anatomía humana, como el Atlas Anatómico Humano Virtual 3D, el Cadáver Virtual 3D, contenidos de Fisiología, Histología, Embriología, Citología, Simulación Médica y varios otros.',
        cadaver:
          'Tener disponible una reconstrucción 3D de un cuerpo humano real para la disección virtual y complementar la enseñanza del laboratorio de anatomía.',
        cadaver3D:
          'El cadáver virtual ilustra la anatomía de un cuerpo masculino real, con sus proporciones y estructuras bien conservadas que revelan los detalles de la morfología interna del organismo. Después de congelar y diseccionar el cuerpo, todas las partes anatómicas fueron fotografiadas y reconstruidas en 3D para facilitar la visualización y el estudio de la anatomía humana.',
        atlas3D:
          'El Atlas Humano reúne las estructuras anatómicas que representan el cuerpo humano. La mayoría de las partes son similares a las del cuerpo masculino y femenino, como los sistemas respiratorio, digestivo, muscular, articular, esquelético, linfático y endocrino. En los sistemas Urogenital, Arterial, Venoso, Nervioso y Tegumentario, algunas estructuras son diferentes, caracterizando cada sexo biológico.',
        blades:
          '¡Más de 200 láminas digitalizadas, permitiendo ampliar hasta 40x, realizar marcaciones y mucho más!',
        contents1:
          'Explore el cuerpo humano en detalles a través de modelos virtuales interactivos en 3D',
        contents2:
          'Contenidos que facilitan el aprendizaje de las disciplinas de la salud humana a través de la interactividad. Integra las áreas de Ciencias Morfológicas, Ciencias Fisiológicas, Ciencias Humanas y Ciencias Sociales Aplicadas a la Salud.',
        organs:
          'Aprenda sobre la anatomía humana de manera interactiva a través de los atlas anatómicos masculino y femenino, y a través del cadáver virtual: una reconstrucción en 3D de un cuerpo humano real. El estudio macroscópico del cuerpo humano se organiza en anatomía completa, que presenta los sistemas y partes anatómicas de manera integrada; anatomía sistémica y anatomía topográfica, que estudian estructuras que forman sistemas orgánicos y regiones anatómicas.',
        cellStructure:
          'Explore las células del cuerpo humano a través de modelos 3D interactivos, explorando los orgánulos que componen los diferentes tipos de células y sus funciones. Además, un conjunto de láminas histológicas que permiten al usuario ver de manera microscópica varias estructuras corporales, como glándulas, órganos y tejidos.',
        development:
          'Estudie fisiología y embriología humana a través de contenido tridimensional virtual que exploran diferentes procesos fisiológicos y etapas del desarrollo embrionario y desarrollo fetal. Los modelos animados permiten al usuario visualizar y comprender el funcionamiento del cuerpo humano, además de demostrar las etapas de su desarrollo, desde la 4ª semana de gestación hasta su nacimiento.',
        specialties:
          'Practique el conocimiento médico de forma práctica desde diferentes perspectivas. La radiología se puede estudiar a través de imágenes DICOM, con herramientas para el manejo de casos clínicos. Conoce el módulo de patología, que utiliza modelos virtuales 3D y láminas histológicas que permiten el estudio de diversas alteraciones morfológicas y funcionales del cuerpo humano. Además, acceda al simulador virtual para experimentar situaciones de emergencia en la clínica médica en la práctica.',
        survey:
          'Te invitamos a llenar un breve formulario, es sencillo y rápido.',
        successShareCollection: 'Nuevos e-mails con acceso:',
        errorShareCollection: 'Error en los seguientes e-mails:',
        emailsWithAccess: 'E-mails con acceso:',
        usersWithAccess: 'Usuarios con acceso:',
        collectionsNotFound: '¡Descubre todo el potencial de las Colecciones!',
        rating: '¿Qué crees que se podría mejorar?',
        'features.collections':
          'Optimice su tiempo con contenido personalizado y compartible, mejorando la calidad del aprendizaje activo.',
        'features.multiplatform':
          'Garantice acceso ilimitado en cualquier dispositivo (web, tablet, móvil), aumentando el compromiso y la flexibilidad del estudiante.',
        'features.laboratory':
          'Elimine gastos en mantenimiento, modelos y materiales invirtiendo en tecnología que maximiza el presupuesto de su institución.',
        'features.support':
          'Proporcione recursos avanzados para el desarrollo de estudios de caso, fortaleciendo la investigación y la innovación en la institución.',
        'features.integration':
          'Incorpore nuestro contenido en su sitio web a través de nuestra API.',
        'features.languages':
          'Contenido mapeado y traducido al portugués, español e inglés.',
        histopathology:
          'This category includes hundreds of histological slides that show tissue and cell pathologies from various systems and anatomical regions of the human body.'
      },
      placeholders: {
        suggestion: 'Deja tu sugerencia',
        optionalSuggestion: 'Deja tu sugerencia (opcional)',
        email: 'Ingrese su correo electrónico',
        phone: 'Ingrese su teléfono',
        password: 'Ingrese su contraseña',
        newPassword: 'Crea tu contraseña',
        token: 'Ingresar código',
        name: 'Ingrese su nombre',
        lastName: 'Ingrese su apellido',
        idNumber: 'Ingrese ID (solo números)',
        search: 'Buscar',
        searchTerms: 'Buscar por términos o títulos',
        searchQuestion: '¿Qué contenidos quieres estudiar?',
        resultsFor: 'Resultados para',
        find: 'Búsqueda',
        country: 'Ingrese su pais',
        profession: 'Ingrese su profesión',
        countrySelect: 'Selecciona tu pais',
        professionSelect: 'Selecciona tu profesión',
        institution:
          'Ingrese el nombre de la institución o empresa a la que pertence',
        departmentSelect: 'Elige un departamento',
        message: 'Escriba su mensaje aquí',
        defaultCollectionTitle: 'Sin título',
        renameCollection: 'Agregar nombre para una nueva carpeta o elemento',
        moveCollection: 'Seleccione la carpeta que desea mover',
        shareCollection: 'Agregar e-mail con qual quiera compartir',
        createFolder: 'Agregar nombre de la nueva carpeta',
        newContent: 'Que hay de nuevo'
      },
      labels: {
        email: 'Correo electrónico',
        password: 'Contraseña',
        newPassword: 'Nueva contraseña',
        oldPassword: 'Contraseña actual',
        repeatPassword: 'Repetir contraseña',
        token: 'Ingrese el código recibido',
        firstName: 'Nombre',
        lastName: 'Apellido',
        fullName: 'Nombre completo',
        guardianName: 'Nombre del Tutor Legal',
        guardianIdNumber: 'ID del Tutor Legal',
        minorName: 'Nombre del menor',
        country: 'Pais',
        profession: 'Profesión',
        institution: 'Nombre de la institución o empresa',
        department: '¿Con qué departamento quieres hablar?',
        isAfya: '¿Su institución pertenece al Grupo Afya?',
        message: 'Mensaje',
        phone: 'Teléfono',
        mobile: 'Teléfono celular',
        language: 'Idioma',
        pt: 'Português',
        es: 'Español',
        en: 'English',
        undefined: 'Indefinido',
        description: 'Descripción',
        details: 'Detalles',
        forbidden: 'Módulo no liberado',
        account: 'Cuenta',
        personalAccount: 'Cuenta Personal',
        corporateAccount: 'Cuenta Corporativa',
        legal: 'Jurídico',
        useTerms: 'Condiciones de Uso',
        politics: 'Política de Privacidad',
        cookies: 'Política de Cookies',
        requests: 'Órdenes del titular',
        dragFile: 'Arrastrar o',
        uploadFile: 'sube tu archivo aquí',
        availability: 'Disponible:',
        contactWhats: '+55 11 96340-0766',
        contactEmail: 'comercial@medicalharbour.com',
        module: 'Módulo',
        modules: 'Módulos',
        newModule: 'Nuevo módulo',
        new: 'Nuevo',
        updated: 'Actualizado',
        newContent: 'Nuevo contenido',
        step: 'Paso',
        renameCollection: 'Nombre de carpeta o elemento',
        moveCollection: 'Mover para',
        shareCollection: 'Compartir carpeta o elemento',
        createdAt: 'Creado el',
        folderName: 'Nombre de la carpeta',
        directLink: 'Enlace directo',
        selectFolder: 'Ubicación del contenido',
        '3d_contents': 'Contenido 3D',
        slides: 'Láminas',
        shearchFolder: 'Buscar carpetas',
        addedAt: 'añadido el',
        myCollection: 'Mi colección',
        myCollections: 'Mis colecciones',
        collectionsSharedWithMe: 'Compartidos conmigo',
        afyaCollections: 'Colecciones Afya',
        order: 'Orden',
        recentsOrder: 'Más recientes',
        alphabeticalOrder: 'Alfabética',
        contentTypeOrder: 'Tipo',
        filter: 'Filtrar',
        type: 'Tipo',
        mostRecent: 'Más reciente',
        recentViewedContents: 'Contenidos accedidos recientemente',
        weeklyTopContents: 'Más accedidos de la semana',
        nextReleasesContents: 'Próximos lanzamientos',
        notifyActivated: '¡Advertencia activada!',
        notifyRelease: 'Avísame cuando se publique',
        filterByModule: 'Filtro por módulos'
      },
      buttons: {
        signup: 'Registrar',
        signin: 'Iniciar sesión',
        enter: 'Acceder',
        save: 'Guardar',
        cancel: 'Cancelar',
        return: 'Regresar',
        exit: 'Salir',
        edit: 'Editar',
        update: 'Actualizar',
        view: 'Visualizar',
        subscribe: 'Suscribir',
        send: 'Enviar',
        adjust: 'Ajustar',
        remember: 'Recuérdame',
        sendData: 'Enviar Datos',
        sendToken: 'Enviar correo electrónico para restablecer',
        resendToken: 'Reenviar código',
        resetPassword: 'Restablecer contraseña',
        changePassword: 'Cambiar Contraseña',
        changeProfile: 'Cambiar Datos',
        changeLanguage: 'Cambiar Idioma',
        changeAvatar: 'Cambiar Foto',
        deleteAccount: 'Borrar Cuenta',
        confirmDelete: 'Borrar de todos modos',
        cancelDelete: 'No borres',
        viewPlan: 'Consultar todos los servicios de su Plan',
        finalizeAccount: 'Finalizar Registro',
        navigation: 'Nociones de Navegación',
        shortcuts: 'Atajos de Teclado',
        demo: 'Solicitar una demostración',
        discover: 'Quiero conocer el BioAtlas',
        openNewTab: 'El enlace se abre en una nueva pestaña.',
        getNews: 'Recibir noticias',
        knowMore: 'Más información',
        knowContent: '$t(buttons.knowMore) sobre nuestro contenido',
        knowModules: '$t(buttons.knowMore) sobre nuestros módulos',
        knowCadaver: '$t(buttons.knowMore) sobre el cadáver virtual',
        askDemo: 'Solicita ahora una demostración para tu institución.',
        askDemoNow: 'Solicita ahora la demo para tu institución',
        requestPresentation: 'Solicitar presentación',
        surveyNo: 'No gracias',
        surveyYes: 'Hagamos el reto',
        seeContent: 'Visualizar contenido',
        keepReading: 'continuar leyendo en el contenido',
        relatedContent: 'Contenidos Relacionados',
        bibliography: 'Bibliografía',
        share: 'Compartir',
        rename: 'Renombrar',
        duplicate: 'Duplicar',
        move: 'Mover',
        delete: 'Eliminar',
        createFolder: 'Crear carpeta',
        sendFeedback: 'Enviar feedback',
        seeAll: 'ver todo',
        emailTab: 'Correo electrónico',
        linkTab: 'Enlace',
        copyLink: 'Copiar enlace',
        linkCopied: '¡Copiado!',
        firstSteps: 'Pinitos',
        navigationAndShortcuts: 'Navegación y accesos directos',
        addNewEmails: 'Agregar nuevos e-mails',
        close: 'Cerrar',
        manageAccess: 'Administrar el acceso',
        addToCollection: 'Agregar a mi colección',
        add: 'Añadir',
        startNow: 'Comenzar ahora',
        applyFilter: 'Aplicar filtro'
      },
      messages: {
        conjunction: 'y',
        separator: 'o',
        optional: 'opcional',
        agreeTerms1: 'Al registrarme, acepto que he leído y aceptado las',
        agreeTerms2: 'Acepto que he leído y aceptado las',
        agreeTermsMinorS:
          'Soy mayor de 18 años y soy consciente de las responsabilidades.',
        agreeTermsMinorL:
          'Soy menor de 18 años y mi tutor legal autoriza a Medical Harbor a recopilar mis datos personales a efectos de comunicaciones electrónicas de ofertas y servicios (SMS, mensajería instantánea, teléfono, correo electrónico) de acuerdo con la $t(labels.politics).',
        validationSent:
          '¡Le enviamos un correo electrónico para validar su registro!',
        contactAdmin: '¡Póngase en contacto con el administrador del sistema!',
        accountReady: '¡Su acceso a BioAtlas está activo!',
        dataSharing: 'Acepte el intercambio de datos para ofertas de productos',
        notifications:
          '¿Acepta recibir notificaciones por SMS, Whatsapp o correo electrónico?',
        deleteQuestion:
          '¿Está seguro de que desea eliminar permanentemente su cuenta?',
        deleteReminder1:
          'Eliminar su cuenta de BioAtlas es una acción permanente y no se puede deshacer.',
        deleteReminder2:
          'Una vez que elimine su cuenta, no podrá volver a iniciar sesión en la aplicación y cualquier modelo 3D que haya creado y guardado en su biblioteca se eliminará de nuestra base de datos de forma permanente y no se podrá restaurar.',
        trialWarning:
          'Estás usando la versión de prueba. Todavía falta {{count}} día.',
        trialWarning_plural:
          'Estás usando la versión de prueba. Todavía quedan {{count}} días.',
        trialUpgrade: 'Obtener la versión PRO.',
        noContent: 'No se encontró contenido para',
        newContent: 'Nuevo contenido que te puede interesar',
        noAccount: '¿Aún no tienes una cuenta?',
        gotAccount: '¿Ya tienes una cuenta?',
        passwordsDontMatch: '¡Las contraseñas deben coincidirse!',
        notYetValidated:
          '¡Aún no ha validado su registro por el correo electrónico que se envió!',
        notYetConfirmed:
          'Aún no has confirmado tu registro. Consultar su correo electrónico.',
        confirmAccount: 'Confirme su cuenta de BioAtlas',
        notYetConfirmed1: 'Antes de cambiar su contraseña,',
        notYetConfirmed2: 'Antes de iniciar sesión,',
        notYetConfirmed3: 'confirme su cuenta por correo electrónico.',
        notYetConfirmed4:
          'No olvides revisar también tu casilla de correo no deseado, ¿de acuerdo?',
        checkData: 'Revisa tus datos e intenta de nuevo',
        loginInvalid: 'Nombre de usuario y/o contraseña no válidos',
        userNotFound: 'Usuario no encontrado',
        wrongPassword: 'La contraseña actual es incorrecta',
        tooManyRequests:
          'Ha ralizado demasiadas solicitudes. Espere un momento y vuelve a intentarlo.',
        tooManyFailedAttempts: 'Has fallado en varios intentos',
        tooManyAttempts: 'Has excedido el límite de intentos',
        tokenSent: 'Código enviado al correo electrónico: {{email}}',
        passwordChanged: '¡Contraseña cambiada con éxito!',
        tokenInvalid:
          'El código proporcionado no es válido. Vuelva a solicitar un código.',
        passwordTooShort: 'La contraseña debe tener al menos 8 caracteres',
        tryAgain:
          '¡Hubo un problema al enviar tu información, inténtalo de nuevo!',
        partialSuccessData:
          'Sus datos se han actualizado con éxito, sin embargo, hubo un problema al cargar su foto.',
        partialSuccessImg:
          'Su foto se actualizó con éxito, sin embargo, hubo un problema al enviar sus datos.',

        requiredField: 'Campo obligatorio',
        invalidEmail: 'Introduzca un correo electrónico válido',
        emailExists:
          'Ya existe una cuenta con el correo electrónico proporcionado',
        phoneExists: 'Este número de teléfono ya está registrado',
        phoneTooShort: 'Número de teléfono no válido.',
        idTooShort: 'Número de identificación no válido.',
        dataUpdated: '¡Datos actualizados con éxito!',
        collectionDeleted: 'Colección eliminada con éxito!',
        alreadySignedUp:
          '¡Ya se ha registrado, inicie sesión con su nombre de usuario y contraseña!',
        invalidLink:
          '¡Este enlace no es válido, comuníquese con su administrador!',
        multipleImages: 'Envía solo un archivo',
        imageType:
          'Este tipo de archivo no es compatible. Extensiones válidas: {{support}}',
        imageSize:
          '¡El archivo es demasiado grande! ({{size}}) El tamaño máximo de carga es de {{limit}}.',
        agreement:
          'Debes aceptar las $t(labels.useTerms) y la $t(labels.politics)',
        guardianData:
          'Como eres menor de edad, necesitas introducir los $t(titles.guardianData)',
        unreachable:
          'Nuestro servidor está experimentando dificultades técnicas. Vuelve a intentarlo más tarde.',
        accessDenied: 'Inicie sesión de nuevo.',
        unverifiedEmail: 'Error: correo electrónico no verificado',
        autoLogin: 'Te estamos iniciando seción.',
        copySuccess: '¡Copiado en el portapapeles!',
        copyError: '¡Error al copiar!',
        unexistingModule: 'Contenido no existe',
        unavailable: 'Contenido no disponible',
        betterExp:
          'Para una mejor experiencia, acceda a nuestra aplicación o a la versión desktop',
        desktop: 'computadora',
        appAvailable: 'Descargue la aplicación BioAtlas en las tiendas',
        support1: 'Póngase en contacto com nuestro',
        support2: 'equipo de soporte',
        crash: 'Algo salió mal con BioAtlas. $t(messages.support1)',
        appDenied:
          'Vimos que no tienes accesso al BioAtlas. $t(messages.support1)',
        contactSuccess1: '¡Hola! ¡Acabamos de recibir tu mensaje!',
        contactSuccess2:
          'Estamos muy contentos de saber que quieres hablar con nosotros. Muchas gracias por su interés en BioAtlas.',
        contactSuccess3:
          'Estamos revisando su mensaje y en breve nos pondremos en contacto con usted para responder a sus preguntas y comentarios.',
        whichContents: 'Cúales capítulos accesarás:',
        errorCollection:
          'Lo siento, ocurrió un error al intentar obtener tus colecciones',
        emptyCollections:
          'Parece que aún no tienes ninguna colección. Elige cualquier modelo 3D, personalízalo a tu manera y guarda ;)',
        emptyCollectionsMobile:
          'Parece que aún no tienes ninguna colección. Accede a tu aplicación para ver tus colecciones.',
        emptyCollectionsShared:
          'Aún no se ha compartido ninguna colección contigo. Cuando alguien comparta una, aparecerá aquí',
        collectionRenamed: '¡Colección renombrada exitosamente!',
        folderRenamed: 'Carpeta renombrada exitosamente!',
        collectionMoved: '¡Colección movida exitosamente!',
        collecionDeleted: '¡Colección excluída exitosamente!',
        collecionShared: '¡Colección compartida exitosamente!',
        collectionUnshared: '¡Colección removida del usuario exitosamente!',
        collectionDuplicated: '¡Colección duplicada exitosamente!',
        collectionFolderCreated: '¡Carpeta creada exitosamente!',
        collectionFolderDuplicateErr: 'Carpeta con este nombre ya existe',
        demoPopUpText1: 'Tienes ',
        demoPopUpTextDays: 'día ',
        demoPopUpTextDaysPlural: 'días ',
        demoPopUpTextMonths: 'mes ',
        demoPopUpTextMonthsPlural: 'meses ',
        demoPopUpText2: 'de acceso demo',
        demoPopUpText3:
          ', tu opinión sobre nuestra plataforma es muy importante.',
        demoExpiredText:
          'Su licencia de demostración ha caducado. Por favor contacte nuestro soporte.',
        demoExpiredBtn: 'Chatea con nuestro equipo',
        errorInputShared: 'No es posible compartir la colección en este email',
        by: 'De',
        deleteCollectionMsgSingular:
          'Al eliminar esta carpeta también se eliminarán las siguientes colecciones o carpetas:',
        deleteCollectionMsgPlural:
          'Al eliminar esta carpeta también se eliminarán las siguientes colecciones o carpetas:',
        folderNotFound: 'Carpeta no encontrada',
        newContentTitle: 'Consulta las últimas novedades de BioAtlas',
        newContentSubtitle: 'Nueva herramienta para guardar tus colecciones',
        newContentText:
          'Ahora puedes crear una colección personalizada de contenido 3D. Con BioAtlas, puedes guardar estos modelos, organizarlos en carpetas y compartirlos de forma sencilla y rápida con tus amigos y alumnos.',
        newContentClose: 'Cerrar',
        to: 'para',
        thankYouRating: 'Gracias por tu valoración',
        pickRateError:
          'Por favor, elija una calificación para este contenido o cambie su calificación / comentario anterior antes de enviarlo.',
        shareCollectionErrorTitle: 'Error al obtener la colección',
        shareCollectionErrorText:
          'No fue posible acceder a la colección que fue compartida contigo. Serás redirigido a la página de inicio',
        expiredCollectionLinkErrorTitle: 'Enlace expirado',
        expiredCollectionLinkErrorText:
          'Obtén un nuevo enlace para acceder a esta colección. Serás redirigido a la página de inicio',
        clipboardPermissionsErrorTitle: 'No fue posible copiar el enlace',
        clipboardPermissionsErrorText:
          'Verifica los permisos del sitio para el portapapeles e inténtalo de nuevo',
        saveCollectionSuccessTitle: 'Contenido añadido',
        saveCollectionSuccessText:
          'El contenido se ha añadido a tu colección con éxito',
        saveCollectionErrorTitle: 'Error al guardar contenido en colecciones',
        saveCollectionErrorText:
          'No se pudo guardar el contenido en este momento. Inténtalo de nuevo más tarde',
        lockedItem: 'Contenido institucional bloqueado',
        lockedFolderNoCreate:
          'No puedes crear carpetas dentro de colecciones institucionales.',
        notFoundContentForTerm: 'No se encontró contenido para el término',
        trySimilarTerms:
          'Intente usar palabras similares o verificar la ortografía.',
        relatedContentsTerm: 'Contenidos relacionados con el término'
      },
      swal: {
        success: 'Éxito',
        warning: 'Atención',
        error: '¡Ha ocurrido un problema!',
        access: 'No tienes accesso',
        crash: '¡Ups!'
      },
      banner: {
        title: '¿Sabías?',
        curiosity1:
          'El cerebro humano tiene aproximadamente 86 mil millones de neuronas. Solo el 19% de ellos están ubicados en la corteza cerebral, mientras que el cerebelo contiene alrededor del 80%. El resto se encuentra en el tronco cerebral.',
        curiosity2:
          'El cuerpo humano brilla en la oscuridad. Este proceso consiste en la emisión de biofotones, caracterizados por reacciones químicas que emiten pequeñas cantidades de luz en nuestras células. No notamos este brillo a simple vista ya que la intensidad es mucho más débil de lo que podemos detectar.'
      },
      alts: {
        load: 'Cargando animación',
        logo: 'Logotipo de BioAtlas',
        eye: 'Icono de ojo para habilitar la visibilidad de la contraseña',
        avatar: 'Foto de perfil de usuario',
        edit: 'Editar icono',
        computer:
          'Imagen de una computadora que le advierte que ha llegado un correo electrónico',
        check: 'Animación de un icono de cheque',
        folder: 'Carpeta',
        home: 'Inicio',
        playstore: 'Imagen de Playstore',
        appstore: 'Imagen de Appstore'
      },
      modules: {
        cytology: 'Citología',
        transports: 'Transporte en la Membrana',
        histology: 'Histología',
        systemicAnatomy: 'Anatomía Sistémica',
        topographicAnatomy: 'Anatomía Topográfica',
        completeAnatomy: 'Anatomía Completa',
        physiology: 'Fisiología',
        embryology: 'Embriología',
        radiology: 'Radiología',
        pathology: 'Patología',
        histopathology: 'Histopatología'
      },
      categories: {
        all: 'Todos',
        tissues: 'Tejidos',
        systems: 'Sistemas',
        organs: 'Órganos Sensoriales',
        atlas: 'Atlas de Anatomía Humana',
        atlas2: 'Atlas Anatómico',
        cadaver: 'Cadáver Virtual'
      },
      improvements: {
        exam_quality: 'Calidad del examen',
        exam_report: 'Informe del examen',
        features: 'Funcionalidades',
        usability_navigation: 'Usabilidad/Navegación',
        other_reason: 'Otro motivo (comente abajo)',
        text: 'Texto',
        slide_quality: 'Calidad de la lámina',
        information_consistency: 'Coherencia de la información',
        sample: 'Muestra',
        structure_identification: 'Identificación de las estructuras',
        morphology: 'Morfología',
        loading: 'Carga',
        content_depth: 'Profundización del contenido'
      },
      subCategories: {
        epithelial: 'Tejido Epitelial',
        connective: 'Tejido Conectivo',
        circulatory: 'Circulatorio',
        articular: 'Articular',
        digestive: 'Digestivo',
        endocrine: 'Endocrino',
        skeletal: 'Esquelético',
        integumentary: 'Tegumentario',
        lymphoid: 'Linfático',
        muscular: 'Muscular',
        nervous: 'Nervioso',
        respiratory: 'Respiratorio',
        urogenital: 'Urogenital',
        male: 'Masculino',
        female: 'Femenino'
      },
      helpers: {
        rotateMouse:
          'Mantenga presionado el botón izquierdo del mouse y muévase para rotar el objeto',
        moveMouseBlade:
          'Mantenga presionado el botón izquierdo del mouse y arrastre para mover la cuchilla',
        moveMouseModel:
          'Mantenga presionado el botón derecho del mouse para mover el objeto en la pantalla',
        selectMouse:
          'Haga clic izquierdo una vez para seleccionar una estructura',
        zoomMouse:
          'Use el botón de desplazamiento del mouse para acercar o alejar',
        textboxMouse:
          'Presione shift en el teclado, haga clic y arrastre el botón izquierdo del mouse',
        cameraKeyboard:
          'Use la tecla (W) para moverse hacia arriba, la tecla (S) para moverse hacia abajo, la tecla (A) para moverse hacia la izquierda y la tecla (D) para moverse hacia la derecha',
        rotateKeyboard:
          'Use la tecla (↑) para girar hacia arriba, la tecla (↓) para girar hacia abajo, la tecla (←) para girar hacia la izquierda y la tecla (→) para girar hacia la derecha',
        zoomKeyboard: 'Use las teclas + y - para hacer zoom',
        moveKeyboard: 'Usa las teclas de flecha para mover la cuchilla',
        rotatePad:
          'Mantén presionado el botón izquierdo del panel táctil y muévelo para rotar',
        movePad:
          'Mantenga presionado el botón derecho del panel táctil y mueva la cámara del objeto',
        zoomPad: 'Haga clic izquierdo una vez para seleccionar una estructura'
      },
      home: {
        banner: {
          title:
            'Contenido Virtual Interactivo 3D para la Enseñanza en el Área de la Salud',
          subtitle:
            'Explore contenido digital interactivo en 3D para la Enseñanza del ciclo básico de salud a través de un navegador web, una aplicación Android/iOS y gafas de realidad virtual'
        },
        specs: {
          title:
            '¡Explore los detalles del cuerpo humano en cualquier momento y en cualquier lugar!',
          item1: 'Acesso Multiplataforma',
          text1:
            'Acceda a través de cualquier navegador web, aplicación de Android o iOS, no se requieren complementos, no se requiere instalación',
          item2: 'Control de Acceso',
          text2:
            'Habilite, controle y analice el acceso de profesores y alumnos',
          item3: 'Disponible en 3 idiomas',
          text3: 'Contenido mapeado y traducido al portugués, español e inglés',
          item4: 'Integración',
          text4:
            'Embárcate en nuestro contenido en su sitio web a través de nuestra API',
          item5: 'Animaciones Interactivas 3D',
          text5:
            'Contenido diverso con animaciones 3D guiadas para facilitar la comprensión',
          item6: 'Realidad Virtual 3D',
          text6:
            'Involucre a estudiantes y profesores a través del entorno inmersivo de Realidad Virtual'
        },
        minibanner: 'Reduzca los costos del laboratorio de anatomía',
        allInOne: {
          title:
            'Una suite multiplataforma para acceder a una Biblioteca Digital Interactiva de contenidos 3D para la Enseñanza en Salud',
          text: 'BioAtlas es una solución que se adapta a diversas herramientas tecnológicas del mercado y permite navegar por Contenidos Digitales Interactivos 3D para la salud utilizando cualquier navegador web o aplicación móvil Android o iOS y Gafas de Realidad Virtual.'
        },
        teaser: 'Conozca un poco más sobre BioAtlas',
        dashboard: {
          title:
            'Dashboard con datos para acompañamiento de indicadores de uso',
          subtitle:
            'Más inteligencia para monitorear el uso del sistema y los resultados a su favor',
          text1:
            'Analice el uso, el compromiso, la performance y otras métricas clave para mejorar el aprendizaje',
          text2: 'Obtenga información de las interacciones de los usuarios'
        },
        quotes: {
          text1:
            'BioAtlas es una excelente herramienta para que el estudiante integre los diferentes contenidos de las ciencias biológicas y de la salud',
          position: 'Profesor de Fisiología Humana y Neurociencia en FMIT'
        },
        carousel: {
          startHere: {
            title: '¿No sabes por dónde empezar?',
            description:
              'Las colecciones Afya contienen contenidos seleccionados y organizados para ti.',
            button: 'Acceder a las colecciones Afya'
          },
          collections: {
            title:
              '¿Quieres compartir tus estudios personalizados de forma sencilla y organizada?',
            description: '¡Crea una colección y compártela con quien quieras!',
            button: 'Acceder a colecciones'
          },
          suggestions: {
            title: '¿No encontraste lo que necesitabas?',
            description:
              'Tu sugerencia puede inspirar los próximos contenidos de la plataforma.',
            button: '¡Vamos!'
          }
        },
        conclusion:
          'Conozca BioAtlas, sus posibilidades y asegure el conocimiento de la Salud de su Institución en cualquier escenario de aprendizaje.',
        'footerBannerSubtitle.1': 'BioAtlas también está en tu bolsillo.',
        'footerBannerSubtitle.2':
          '¡Descarga la app y lleva tus estudios contigo!'
      },
      contentTypes: {
        unity: 'Contenido 3D',
        slide: 'Láminas',
        dicom: 'Imágenes'
      },
      contents: {
        banner: {
          title:
            'Explore el cuerpo humano en detalle a través de modelos virtuales interactivos en 3D',
          subtitle:
            'BioAtlas te permite navegar por el cuerpo humano de forma virtual totalmente interactiva utilizando cualquier navegador web, smartphone o gafas de Realidad Virtual.',
          obs: '*Está disponible en 3 idiomas: portugués, inglés y español'
        },
        systems: {
          title: 'Sistemas del cuerpo humano',
          completeAnatomy: {
            text1:
              'tiene más de 2500 estructuras etiquetadas de todos los sistemas anatómicos del cuerpo humano. Este módulo está separado en modelos masculino y femenino y está organizado según sus 12 sistemas anatómicos y 9 regiones.',
            text2:
              'es una reconstrucción en 3D de un cuerpo humano real que fue donado para investigación*. Se congeló, se dividió en 1878 partes y se fotografió con equipos de muy alta resolución. El cadáver virtual ha conservado los colores, está segmentado y mapeado para una visualización completa.',
            obs1: '*La versión 3D en Realidad Virtual - VR - es una forma inmersiva para  entender y comprender el cuerpo humano a un paso del metaverso.',
            obs2: '*Conoce más sobre el Proyecto Visible Human'
          },
          topographicAnatomy: {
            text: 'Navegue por los Elementos Descriptivos del Cráneo y las regiones anatómicas: cabeza y cuello, miembro superior derecho, miembro superior izquierdo, espalda, tórax, abdomen, pelvis, miembro inferior derecho y miembro inferior izquierdo.'
          },
          systemicAnatomy: {
            text: 'Sistemas anatómicos: tegumentario, muscular, esquelético, articular, nervioso, linfático, digestivo, respiratorio, arterial, venoso, endocrino y urogenital.'
          },
          physiology: {
            text: 'Explore el funcionamiento normal y las funciones del cuerpo humano a través de contenido virtual interactivo en 3D:',
            item1: 'Ciclo del corazón',
            item2: 'Contracción de la fibra muscular',
            item3: 'Generación y Conducción del Potencial de Acción',
            item4: 'Hematosis',
            item5: 'Transmisión sináptica',
            item6: 'Ventilación pulmonar'
          }
        },
        cellStructure: {
          title: 'Estructura celular y microanatomía',
          cytology: {
            title: 'Citología 3D',
            text: 'El módulo de Citología permite al usuario interactuar con dos categorías de contenido 3D: Células y Membrana celular. Navega por las células: Célula Eucariota de origen animal, Célula Sanguínea, Neurona y Fibra Muscular. Visualice un modelo de membrana celular en 3D con cinco animaciones relacionadas con el transporte de moléculas a través de la membrana:',
            item1: 'Difusión simple',
            item2: 'Difusión facilitada',
            item3: 'Bomba de sodio y potasio',
            item4: 'Co-transporte',
            item5: 'Contratransporte'
          },
          histology: {
            text: 'BioAtlas dispone de un módulo dedicado al estudio de láminas de glándulas, órganos, tejidos y sistemas, y láminas con patologías. Además de disponer de una herramienta con recursos para su visualización y análisis.'
          }
        },
        development: {
          title: 'Desarrollo humano',
          embryology: {
            text: 'Realice un seguimiento del desarrollo embrionario y fetal, desde la quarta semana de gestación hasta el nacimiento, a través de animaciones 3D interactivas.'
          }
        },
        specialties: {
          title: 'Especialidades medicas',
          radiology: {
            text: 'Sistema de visualización de imágenes DICOM con herramientas para el manejo de casos y estudios clínicos radiológicos. Te permite visualizar imágenes de diferentes modalidades como tomografías computarizadas, resonancias magnéticas, radiografías, entre otras, a través del navegador web.'
          }
        },
        collections: {
          notFound:
            'Mira el video a continuación y descubre, en la práctica, cómo cada funcionalidad puede transformar tu forma de estudiar y explorar los contenidos.'
        },
        conclusion:
          'Póngase en contacto para obtener información sobre BioAtlas'
      },
      onboarding: {
        steps: {
          step1:
            'Paso 1: ¡Queremos conocerte mejor! ¿Con qué área de la salud te identificas más?',
          step2: 'Paso 2: Especialidad o Interés Principal',
          step3: 'Paso 3: Momento en la carrera o formación',
          step4: 'Paso 4: Objetivo principal en BioAtlas',
          step5: 'Paso 5: Preferencia de aprendizaje',
          step6: 'Paso 6: Tiempo semanal disponible'
        },
        auxiliaryTexts: {
          step1: 'Elige solo un área.',
          step2:
            '¿Cuál es tu especialidad o área de interés? (Si no tienes una, puedes elegir "Interés general")',
          step3: '¿En qué etapa de tu viaje te encuentras?',
          step4: '¿Qué buscas en la plataforma?',
          step5: '¿Cómo prefieres aprender?',
          step6: '¿Cuánto tiempo dedicas a estudiar cada semana?'
        },
        buttons: {
          skip: 'Omitir y hacer después',
          continue: 'Continuar',
          finish: 'Finalizar y acceder a BioAtlas',
          back: 'Volver'
        },
        stepBar: {
          of: '{{step}} de {{totalSteps}}'
        },
        healthAreas: {
          medicine: 'Medicina',
          nursing: 'Enfermería',
          pharmacy: 'Farmacia',
          physiotherapy: 'Fisioterapia',
          nutrition: 'Nutrición',
          biomedicine: 'Biomedicina',
          dentistry: 'Odontología',
          physical_education: 'Educación Física',
          others: 'Otros'
        },
        specialties: {
          medicine: {
            clinical_medicine: 'Medicina Clínica',
            pediatrics: 'Pediatría',
            general_surgery: 'Cirugía General',
            gynecology_obstetrics: 'Ginecología / Obstetricia',
            cardiology: 'Cardiología',
            orthopedics: 'Ortopedia',
            dermatology: 'Dermatología',
            emergency: 'Emergencias',
            geriatrics: 'Geriatría',
            ophthalmology: 'Oftalmología',
            pathology: 'Patología',
            general_interest: 'Interés General',
            others: 'Otros'
          },
          nursing: {
            medical_surgical_nursing: 'Enfermería Médico-Quirúrgica',
            pediatric_nursing: 'Enfermería Pediátrica',
            obstetric_nursing: 'Enfermería Obstétrica',
            mental_health_nursing: 'Enfermería en Salud Mental',
            emergency_nursing: 'Enfermería de Emergencias',
            geriatric_nursing: 'Enfermería Geriátrica',
            public_health_nursing: 'Enfermería en Salud Pública',
            occupational_nursing: 'Enfermería del Trabajo',
            others: 'Otros'
          },
          pharmacy: {
            hospital_pharmacy: 'Farmacia Hospitalaria',
            clinical_pharmacy: 'Farmacia Clínica',
            clinical_analysis: 'Análisis Clínicos',
            pharmaceutical_industry: 'Industria Farmacéutica',
            community_pharmacy: 'Farmacia Comunitaria',
            compounding_pharmacy: 'Farmacia de Preparación',
            toxicology: 'Toxicología',
            pharmacovigilance: 'Farmacovigilancia',
            cosmetology: 'Cosmetología',
            others: 'Otros'
          },
          physiotherapy: {
            neurological_physiotherapy: 'Fisioterapia Neurológica',
            respiratory_physiotherapy: 'Fisioterapia Respiratoria',
            cardiovascular_physiotherapy: 'Fisioterapia Cardiovascular',
            dermatofunctional_physiotherapy: 'Fisioterapia Dermato-funcional',
            geriatric_physiotherapy: 'Fisioterapia Geriátrica',
            pediatric_physiotherapy: 'Fisioterapia Pediátrica',
            women_health_physiotherapy: 'Fisioterapia en Salud de la Mujer',
            sports_physiotherapy: 'Fisioterapia Deportiva',
            others: 'Otros'
          },
          nutrition: {
            clinical_nutrition: 'Nutrición Clínica',
            sports_nutrition: 'Nutrición Deportiva',
            public_health_nutrition: 'Nutrición en Salud Pública',
            maternal_child_nutrition: 'Nutrición Materno-Infantil',
            geriatric_nutrition: 'Nutrición Geriátrica',
            hospital_nutrition: 'Nutrición Hospitalaria',
            others: 'Otros'
          },
          biomedicine: {
            clinical_analysis: 'Análisis Clínicos',
            molecular_biology: 'Biología Molecular',
            radiology_diagnostic_imaging: 'Radiología / Diagnóstico por Imagen',
            microbiology: 'Microbiología',
            immunology: 'Inmunología',
            hematology: 'Hematología',
            blood_bank_hemotherapy: 'Banco de Sangre / Hemoterapia',
            genetics: 'Genética',
            parasitology: 'Parasitología',
            aesthetics: 'Estética',
            others: 'Otros'
          },
          dentistry: {
            dental_aesthetics_restorative:
              'Odontología Estética / Restauradora',
            endodontics: 'Endodoncia',
            periodontics: 'Periodoncia',
            oral_maxillofacial_surgery: 'Cirugía Bucomaxilofacial',
            orthodontics: 'Ortodoncia',
            pediatric_dentistry: 'Odontopediatría',
            dental_prosthetics: 'Prótesis Dental',
            dental_radiology: 'Radiología Odontológica',
            oral_pathology: 'Patología Bucal',
            others: 'Otros'
          },
          physical_education: {
            school_physical_education: 'Educación Física Escolar',
            sports_training: 'Entrenamiento Deportivo',
            physical_activity_health: 'Actividad Física y Salud',
            recreation_leisure: 'Recreación y Ocio',
            bodybuilding_conditioning: 'Musculación / Acondicionamiento',
            rehabilitation_therapeutic_exercise:
              'Rehabilitación / Ejercicio Terapéutico',
            workplace_gymnastics: 'Gimnasia Laboral',
            psychomotricity: 'Psicomotricidad',
            special_populations_physical_activity:
              'Actividad Física para Poblaciones Especiales',
            others: 'Otros'
          },
          others: {
            general_interest: 'Interés General',
            others: 'Otros'
          }
        },
        academicLevels: {
          student: 'Estudiante de pregrado',
          resident: 'Residente / Posgrado',
          professor: 'Profesor / Investigador'
        },
        semesters: {
          '1-2': '1º - 2º semestre',
          '3-4': '3º - 4º semestre',
          '5-6': '5º - 6º semestre',
          '7+': '7º+ semestre'
        },
        objectives: {
          study: 'Seguir materias de la universidad',
          pass_exams: 'Aprobar exámenes (residencia, concurso)',
          practical: 'Aprender habilidades prácticas',
          personal_interest: 'Explorar nuevos contenidos por interés personal'
        },
        learningPreferences: {
          videos: 'Videos',
          summaries: 'Resúmenes organizados',
          articles: 'Artículos',
          clinical_cases: 'Casos clínicos y ejercicios',
          audios: 'Podcasts y audio-clases',
          study_group: 'Grupos de estudio y foros'
        },
        weeklyTime: {
          '3h': 'Poco tiempo (Hasta 3h/semana)',
          '4-7h': 'Algunas horas (4 a 7h/semana)',
          '8h': 'Mucho tiempo (8h o más)'
        },
        subtexts: {
          healthAreaOthers:
            '¿Quieres explorar otras áreas de la salud? ¡Escribe aquí tus preferencias!',
          specialtyOthers:
            '¿Quieres explorar otras especialidades? ¡Escribe aquí tus preferencias!',
          semesterTitle: 'Año / Semestre:'
        },
        tempContent: {
          stepContent: 'Contenido del {stepText}',
          tempArea:
            'Esta es un área temporal para el contenido específico de cada etapa.'
        },
        editBanner: {
          title: '¿Qué tal completar tu perfil?',
          subtitle: 'Con esto, entendemos mejor tus intereses y preferencias.',
          editProfile: 'Editar mi perfil',
          letsGo: 'Vamos'
        }
      },
      integration: {
        banner: {
          title: 'Agregue interactividad BioAtlas 3D a su contenido',
          subtitle:
            'Dé vida a su proyecto de atención médica agregando su marca a BioAtlas o incorporando nuestras animaciones, piezas virtuales interactivas a través de la integración API de BioAtlas.'
        },
        api: {
          label: 'API BioAtlas',
          title:
            'Contenido 3D de BioAtlas en su proyecto a través de nuestra API',
          subtitle:
            'Construya una experiencia interactiva virtual 3D en su proyecto relacionado con la anatomía u otras disciplinas relacionadas con el ciclo básico en Salud. El contenido de BioAtlas se puede integrar fácilmente en su sitio web, contenido digital, LMS o proyecto digital a través de la API de BioAtlas.'
        },
        institutions: {
          label: 'Instituciones',
          title: 'BioAtlas para su institución',
          item1: 'Farmacéutico',
          item2: 'Universidades',
          item3: 'Hospitales',
          item4: 'Editores'
        },
        whiteLabel: {
          label: 'White Label',
          title: 'BioAtlas con la marca de tu Institución',
          subtitle:
            'BioAtlas cuenta con una solución “Private Label”, que le permite marcar su Institución, convirtiéndola en una solución 100% personalizada.'
        }
      },
      contactPage: {
        form: {
          step: 'Paso',
          of: 'de',
          select: 'Selecione',
          title: 'Solicite ahora su demostración gratuita de BioAtlas',
          previousButton: 'Volver',
          nextButton: 'Continuar',
          submitButton: 'Enviar solicitud',
          businessEmail: 'Ingrese su correo electrónico comercial',
          allowReceiveEmails: 'Acepto recibir novedades por correo electrónico',
          fullName: '¡Genial! Ahora, ingrese su nombre completo',
          phone: '¡Muy bien! Ahora, ingrese su número de teléfono / WhatsApp',
          institutionName: '¿Cuál es el nombre de su institución?',
          profession: '¿Cuál es su cargo o profesión?',
          professions: {
            coordinator: 'Coordinador(a) del Curso',
            professor: 'Profesor(a)',
            student: 'Estudiante',
            others: 'Otros'
          },
          privacyPolicy: {
            text: 'Al enviar mis datos personales, autorizo a BioAtlas a recopilar, procesar y almacenar mi información de acuerdo con el Aviso de Privacidad, como se describe en el ',
            link: 'Aviso de Privacidad de BioAtlas'
          },
          success: {
            header: '¡Su solicitud de demostración ha sido enviada con éxito!',
            label:
              'Nos pondremos en contacto pronto para programar una demostración de BioAtlas.'
          },
          error: {
            header: 'Ocurrió un error al enviar tu información.',
            label: 'Por favor, inténtalo de nuevo más tarde.'
          }
        },
        contentSuggestion: {
          title: '¿Qué contenido te gustaría estudiar en BioAtlas?',
          moduleLabel: '¿En qué módulo de BioAtlas encaja este contenido?',
          modulePlaceholder: 'Seleccione el módulo',
          titleLabel: 'Título o tema del contenido',
          titlePlaceholder:
            'Ej: Embriología del corazón, Casos clínicos de trauma',
          detailsLabel: 'Detalles adicionales (opcional)',
          detailsPlaceholder:
            'Describe lo que te gustaría ver o cómo este contenido podría ayudar',
          submitting: 'Enviando...',
          submit: 'Enviar sugerencia',
          successMessage:
            '¡Tu sugerencia ha sido enviada con éxito! Gracias por contribuir con BioAtlas.'
        }
      },
      landingV2: {
        heroBanner: {
          title: 'Un ecosistema de herramientas para la educación en salud',
          subtitle:
            'BioAtlas contribuye a mejorar el trabajo docente y el proceso de aprendizaje de los estudiantes.',
          button: 'Solicitar presentación',
          note: '*BioAtlas es exclusivo para Instituciones Educativas'
        },
        sectionAppBioAtlas: {
          title:
            'BioAtlas también cuenta con una aplicación exclusiva para los usuarios de tu institución',
          downloadText: 'Disponible para descargar en',
          button: 'Conocer más sobre la App'
        },
        sectionCtaBioAtlas: {
          text: 'Descubra cómo BioAtlas transforma la enseñanza.<br/>Solicite una presentación gratuita y explore esta<br/>innovación en acción!',
          button: 'Solicitar presentación'
        },
        sectionCtaCytology: {
          text: 'Eleva la enseñanza y el aprendizaje de la Medicina<br/>con BioAtlas.',
          button: 'Solicitar presentación'
        },
        sectionEnriquecaAulas: {
          title: 'Enriquece tus clases de salud humana con nuestro contenido',
          blocks: {
            visualizacao: {
              title: 'Visualización Interactiva en 3D',
              text: 'Reconocemos que el aprendizaje efectivo sobre el cuerpo humano y sus complejidades requiere más que la simple memorización de términos. Para mejorar la comprensión de la educación en salud humana, BioAtlas ofrece un enfoque innovador e inmersivo.'
            },
            integracao: {
              title: 'Integración',
              text: 'Realiza cortes y guarda secciones específicas del contenido disponible, delimitando la información de interés de acuerdo a tus necesidades de investigación o estudio.'
            },
            customizacao: {
              title: 'Visualización Personalizada',
              text: 'Es posible realizar cortes, secciones y guardar el contenido personalizado en colecciones.'
            }
          }
        },
        sectionEstudanteProfissional: {
          title: 'Del estudiante al profesional',
          subtitle: 'una solución completa para la educación en salud',
          bullets: {
            otimizacao: {
              title: 'Optimización de costos - ',
              text: 'Reducción significativa de gastos con el mantenimiento de laboratorios, piezas anatómicas y estructuras físicas complejas.'
            },
            potencializacao: {
              title: 'Potenciación de Resultados - ',
              text: 'BioAtlas mejora el aprendizaje, el compromiso, la retención de los estudiantes y el rendimiento en las evaluaciones.'
            },
            recurso: {
              title: 'Recurso Pedagógico Esencial - ',
              text: 'Un recurso educativo que apoya las metodologías activas, el intercambio de colecciones y la preparación práctica para la enseñanza diaria.'
            },
            praticidade: {
              title: 'Practicidad - ',
              text: 'Facilita el trabajo docente, centralizando todos los recursos en una sola herramienta.'
            },
            disponivel: {
              title: 'Disponible donde estés - ',
              text: 'Contenido multiplataforma, disponible en entornos web y móviles, permitiendo descargas y estudio dentro y fuera del aula.'
            }
          }
        },
        sectionModulosBioAtlas: {
          title:
            'Descubre nuestros módulos para un estudio profundo y completo del cuerpo humano',
          fallbackText: 'Imagen en breve',
          knowMore: 'Saber más',
          modules: {
            histologia: 'Histología',
            patologia: 'Patología',
            histopatologia: 'Histopatología',
            radiologia: 'Radiología',
            fisiologia: 'Fisiología',
            embriologia: 'Embriología',
            citologia: 'Citología',
            anatomiaTopografica: 'Anatomía Topográfica',
            anatomiaSistemica: 'Anatomía Sistémica',
            anatomiaCompleta: 'Anatomía Completa'
          }
        },
        sectionResults: {
          title: 'Resultados que marcan la diferencia',
          cards: {
            alunos: { text1: 'Utilizado por más de', text3: 'estudiantes' },
            instituicoes: {
              text1: 'Presente en',
              text2: 'más de',
              text3: 'Instituciones Educativas'
            },
            conteudos: { text1: 'Más de', text3: 'Contenidos interactivos' }
          }
        },
        sectionSolucaoBioAtlas: {
          title:
            'BioAtlas: Una solución robusta diseñada para todos los miembros <br /> de tu Institución Educativa de salud humana',
          altProfessores: 'Solución para Profesores',
          altAlunos: 'Solución para Estudiantes',
          professores: {
            title: 'Para Profesores:',
            list: [
              'Contenido visual y actualizado para involucrar a los estudiantes',
              'Crea y comparte colecciones de contenido',
              'Acceso multiplataforma (móvil, computadora, tableta)',
              'Capacitación simple',
              'Integración con plataformas institucionales'
            ],
            button: 'Saber más',
            staticTitle: 'Para profesores',
            staticSubtitle: 'Saber más'
          },
          alunos: {
            title: 'Para estudiantes:',
            list: [
              'Facilidad para compartir colecciones.',
              'Acceso multiplataforma'
            ],
            button: 'Saber más',
            staticTitle: 'Para alumnos',
            staticSubtitle: 'Saber más'
          }
        },
        sectionVantagensInstituicao: {
          title: 'Ventajas de BioAtlas para tu Institución',
          buttons: {
            acesso: 'Acceso',
            multilingue: 'Multilingüe',
            integracao: 'Integración',
            treinamento: 'Entrenamiento',
            ensino: 'Enseñanza diversificada',
            colecoes: 'Colecciones'
          },
          content: {
            acesso: {
              p1: 'El <bold>Acceso</bold> a BioAtlas es facilitado:',
              b1: '<bold>Simplificado:</bold> Utiliza el inicio de sesión y la contraseña institucionales (<bold>SSO - Single Sign-On</bold>) para proporcionar acceso directo a la plataforma. Alternativamente, explora las opciones de acceso <bold>vía EzProxy o dirección IP</bold> de tu universidad.',
              b2: '<bold>Multiplataforma:</bold> Contenido accesible en cualquier lugar y en cualquier dispositivo, ya sea a través de un navegador <bold>web</bold>, o mediante nuestra aplicación nativa, disponible para teléfonos inteligentes y tabletas (<bold>Android e iOS</bold>).'
            },
            multilingue: {
              p1: 'BioAtlas fue desarrollado con soporte nativo para los siguientes idiomas:',
              b1: 'Portugués',
              b2: 'Español',
              b3: 'Inglés',
              pAfter:
                'Esta funcionalidad multilingüe asegura que la experiencia del usuario, la interfaz, la navegación y el acceso a la documentación sean fluidos e intuitivos para los hablantes de estos tres idiomas, maximizando el potencial de uso y la inclusión de la plataforma en diversos contextos geográficos y académicos.'
            },
            integracao: {
              p1: '<bold>Integra los contenidos</bold> nativos de BioAtlas (como modelos 3D, animaciones, láminas y exámenes radiológicos) <bold>directamente en la plataforma educativa (o LMS)</bold> de tu Institución Educativa.',
              p2: 'Asegura la <bold>mejora de tu entorno virtual</bold> con un acceso sencillo a los recursos y soporte técnico especializado.'
            },
            treinamento: {
              p1: '<bold>Nuestro equipo de especialistas</bold> está totalmente preparado para ofrecer una formación completa y eficiente a los miembros del cuerpo docente de tu institución.',
              p2: 'A través de <bold>sesiones interactivas</bold> y soporte continuo, nos aseguramos de que tus profesores e instructores adquieran las habilidades y el dominio de las herramientas necesarias para <bold>integrar las soluciones BioAtlas en sus rutinas de trabajo</bold> y potenciar el proceso de enseñanza-aprendizaje.'
            },
            ensino: {
              p1: 'BioAtlas ofrece una colección digital rica y detallada, con <bold>miles de contenidos 3D animados</bold> de alta fidelidad para la visualización interactiva de estructuras biológicas complejas.',
              p2: 'La plataforma también proporciona una colección de <bold>láminas histológicas e histopatológicas</bold> digitalizadas en alta resolución, esenciales para el estudio de la microanatomía y patologías.',
              p3: 'Complementariamente, incluye un robusto <bold>módulo de diagnóstico por imagen</bold> (RM, TC, US, Rayos X), permitiendo la práctica en la interpretación de exámenes reales.'
            },
            colecoes: {
              p1: 'Las Colecciones BioAtlas permiten agrupar contenidos 3D, láminas e imágenes radiológicas en carpetas, aplicando filtros inteligentes que brindan un acceso rápido, lógico y fluido.',
              p2: 'Permiten a los <bold>profesores estructurar clases</bold> con mayor claridad y a los <bold>estudiantes realizar revisiones con propósito</bold>, todo integrado en la misma plataforma.',
              p3: 'Representan el vínculo entre contenido, metodología y compromiso.'
            }
          }
        },
        sectionDepoimentos: {
          title: 'Mira lo que dicen nuestros usuarios sobre BioAtlas',
          testimonials: [
            {
              text: 'BioAtlas es una excelente herramienta para que el alumno integre los diferentes contenidos de las ciencias biológicas y de la salud.',
              author: 'Dr. Rodolfo Souza de Faria',
              role: 'Profesor de Fisiología Humana y Neurociencias en FMIT'
            },
            {
              text: 'Muy genial ver las partes de la anatomía humana de forma interactiva, didáctica y de una forma de tener una visión mejorada de cada parte del cuerpo humano muy cercana a la realidad.',
              author: 'Ana Paula Gomes Peixoto',
              role: 'Afya Facultad de Ciencias Médicas Contagem'
            },
            {
              text: 'BioAtlas está siendo fundamental en este momento de mi trayectoria académica. Material de excelente calidad y fácil manejo, facilitando así, la comprensión y el aprendizaje.',
              author: 'Luciana De Almeida Da Cunha',
              role: 'ULBRA'
            },
            {
              text: 'Sí recomendaría BioAtlas a un amigo o colega porque tiene contenidos que ayudan bastante a los alumnos a estudiar. Me ayuda en las clases teóricas y prácticas de la Universidad.',
              author: 'Daniel Vieira de Souza Martins',
              role: 'Unigranrio'
            },
            {
              text: 'BioAtlas es una maravillosa plataforma de contenido médico para fortalecer el conocimiento y la práctica de estudiantes y profesionales médicos.',
              author: 'Dra Briseida Estefanía Castillón Betancourt',
              role: 'Médico Cirujano y Partero - IMSS - México'
            },
            {
              text: 'BioAtlas es fundamental para la enseñanza de Anatomía y de los sistemas fisiológicos, auxiliando mucho en la didáctica docente, contribuyendo para la consolidación de los conocimientos por parte de los alumnos.',
              author: 'Dra. Ludmila Alem',
              role: 'Prof. de Anatomía - UFRJ <br />Prof. de SOI - Medicina Afya | Unigranrio'
            }
          ]
        },
        logosCarousel: {
          title:
            'Confiado por instituciones líderes en más de <span>20</span> países'
        },
        collectionsPage: {
          banner: {
            title: 'Organiza el conocimiento. Inspira el aprendizaje.',
            subtitle: 'Colecciones BioAtlas',
            text: 'Las Colecciones BioAtlas te permiten agrupar los Contenidos disponibles en secuencias didácticas, creando experiencias de aprendizaje visuales, conectadas y fáciles de compartir.',
            btnText: 'Solicitar presentación'
          },
          explanation: {
            title: 'Cómo funcionan las Colecciones',
            paragraph1:
              'Las Colecciones BioAtlas ofrecen una organización inteligente para tu material de estudio.',
            paragraph2:
              'Agrupa fácilmente contenidos 3D, láminas e imágenes radiológicas en carpetas con filtros inteligentes, garantizando un acceso rápido, lógico e intuitivo.',
            paragraph3:
              'En la misma plataforma, los profesores pueden estructurar las clases con claridad, y los alumnos pueden revisar el contenido con enfoque y propósito.',
            paragraph4:
              'Las Colecciones BioAtlas son el vínculo perfecto entre contenido relevante, metodología de enseñanza eficaz y compromiso del alumno.',
            btnText: 'Solicitar presentación',
            upperCards: {
              saveChanges: {
                title: 'Guarda los cambios realizados en los Contenidos 3D',
                text: 'Personaliza el contenido con cuadros de texto, etiquetas, flechas y otros elementos, guardándolo directamente en tus colecciones.'
              },
              shareCollection: {
                title: 'Comparte tu colección con facilidad',
                text: 'Con solo un clic, creas un enlace para compartir tu colección con alumnos y docentes.'
              }
            },
            lowerCard: {
              title: 'Organización inteligente',
              text: 'Agrupa tus colecciones en carpetas, usa filtros por contenido y encuentra exactamente lo que necesitas — en segundos.'
            }
          },
          visualizer: {
            title:
              'Aumenta la interacción profesor-alumno y la calidad de los estudios con las Colecciones BioAtlas',
            items: {
              integratedToCurriculum: {
                btnTitle: 'Integradas al currículo',
                text: 'Alinea de forma estratégica y detallada cada colección de recursos y materiales didácticos a los objetivos de aprendizaje específicos y a las metodologías pedagógicas de cada disciplina curricular.'
              },
              teaching: {
                btnTitle: 'Didácticas',
                text: 'El aprendizaje se vuelve activo y significativo con el incentivo a la interacción con la colección, la revisión constante del material y el intercambio de descubrimientos con los compañeros.'
              },
              sequential: {
                btnTitle: 'Secuencial',
                text: 'Las Colecciones BioAtlas organizan el conocimiento de manera significativa, ayudando al alumno a comprender la secuencia lógica entre los temas.'
              },
              diversified: {
                btnTitle: 'Diversificada',
                text: 'Las Colecciones BioAtlas permiten agrupar de manera inteligente una amplia gama de contenidos digitales, incluidos modelos 3D detallados, láminas de microscopía virtual e imágenes radiológicas, todo en carpetas personalizables.'
              }
            }
          }
        },
        resourcesPage: {
          banner: {
            title: 'Explora el cuerpo humano de una nueva manera',
            text: 'Estudia Anatomía, Láminas Histológicas y Exámenes Radiológicos de forma integrada, práctica y atractiva a través de los visualizadores de BioAtlas.',
            btnText: 'Solicitar presentación'
          },
          visualizer3d: {
            title: 'Visualizador 3D',
            subtitle: 'Herramientas disponibles',
            text: 'Visualiza estructuras anatómicas en alta calidad desde cualquier ángulo.',
            items: {
              chapters: {
                btnTitle: 'Capítulos',
                text: 'Muchas de las animaciones de BioAtlas están divididas en capítulos, que ayudan a comprender los detalles de cada contenido. Cada capítulo está diseñado para cubrir un aspecto específico y fundamental, garantizando que la comprensión de los temas más complejos se construya paso a paso, haciendo el aprendizaje más eficiente y accesible.'
              },
              search: {
                btnTitle: 'Búsqueda',
                text: 'Sumérgete en las estructuras a través de la búsqueda dentro del visualizador y explora en detalle el contenido presentado. Esta funcionalidad permite a los usuarios localizar y aislar elementos específicos con precisión.'
              },
              slice: {
                btnTitle: 'Corte',
                text: 'Con la herramienta de corte puedes definir planos de corte precisos a lo largo de los tres ejes espaciales — X (ancho), Y (alto) y Z (profundidad). Esto posibilita la disección virtual del modelo u objeto en cuestión, revelando capas, composiciones y detalles que estarían ocultos en la visualización superficial.'
              },
              annotations: {
                btnTitle: 'Anotaciones',
                text: 'Realiza anotaciones en cualquier contenido, marca, resalta o comenta directamente donde reside la información. Añade tus reflexiones, preguntas o resúmenes junto al contenido.'
              },
              tags: {
                btnTitle: 'Etiquetas',
                text: 'Utiliza las etiquetas para marcar detalles específicos y realizar consultas posteriores de forma eficiente y precisa. Esta es una herramienta poderosa para la organización y gestión de la información.'
              },
              flashcards: {
                btnTitle: 'Flashcards',
                text: 'Los Flashcards son recursos dentro de los contenidos por capítulo, con el objetivo de reforzar el aprendizaje activo, permitiendo que el alumno revise conceptos de forma rápida e interactiva.'
              },
              accessibility: {
                btnTitle: 'Accesibilidad',
                text: 'BioAtlas ofrece un conjunto robusto de recursos de accesibilidad y personalización meticulosamente desarrollados para garantizar que cada usuario pueda optimizar su experiencia de navegación y estudio. Recursos para facilitar el acceso y la comprensión de los contenidos presentados: cambia el diseño, tamaño de fuente y mucho más.'
              },
              animation: {
                btnTitle: 'Animación',
                text: 'Animaciones digitales interactivas y exclusivas, meticulosamente elaboradas para ser herramientas poderosas de enseñanza y aprendizaje. Cada pieza de contenido está concebida para transformar conceptos complejos en narrativas visuales atractivas, facilitando la comprensión y retención del material por parte de los usuarios.'
              }
            }
          },
          visualizerSlides: {
            title: 'Visualizador de láminas histológicas',
            subtitle: 'Herramientas',
            text: 'Las láminas digitales en alta resolución permiten observar detalles con nitidez, aplicar zoom y comparar estructuras, todo directamente desde el navegador.',
            items: {
              measure: {
                btnTitle: 'Medición',
                text: 'Realiza mediciones directamente sobre la lámina digital, permitiendo analizar el tamaño y la proporción de estructuras histológicas con precisión. Ideal para estudios morfológicos y comparaciones entre tejidos.'
              },
              progressiveZoom: {
                btnTitle: 'Zoom progresivo',
                text: 'Explora la lámina en diferentes niveles de ampliación, desde el campo general hasta los detalles microscópicos. El zoom progresivo simula la experiencia del microscopio óptico, facilitando la comprensión gradual de las estructuras celulares. Simula los niveles clásicos de microscopía óptica, permitiendo alternar entre ampliaciones predefinidas: 2x 4x 8x 10x 20x 40x.'
              },
              marker: {
                btnTitle: 'Marcador',
                text: 'Agrega marcaciones personalizadas sobre la lámina para destacar regiones de interés, apoyar explicaciones y registrar observaciones importantes durante el estudio o la clase.'
              },
              panoramic: {
                btnTitle: 'Panorámica',
                text: 'Navega libremente por la lámina en alta resolución, explorando toda la extensión del tejido con fluidez y control. La visualización panorámica facilita la contextualización espacial de las estructuras analizadas.'
              },
              pinsAndArrows: {
                btnTitle: 'Pins y flechas',
                text: 'Utiliza pins y flechas para señalar y destacar estructuras específicas de la lámina, haciendo la explicación visual más clara y objetiva, especialmente en actividades didácticas y presentaciones.'
              },
              infoPanel: {
                btnTitle: 'Panel de información',
                text: 'Accede a información detallada sobre la lámina, como tipo de tejido, coloración, tipo de corte y descripción histológica, apoyando la interpretación correcta y el aprendizaje teórico integrado a la imagen.'
              }
            }
          },
          visualizerDicom: {
            title: 'Visualizador de radiología',
            subtitle: 'Herramientas avanzadas',
            text: 'Aprende a interpretar exámenes de imagen con contexto clínico.',
            items: {
              reports: {
                btnTitle: 'Informes',
                text: 'Analiza informes radiológicos de forma detallada directamente en el visualizador, con información importante como modalidad del examen, región del cuerpo, sexo y hallazgos, para una mejor comprensión del estudio.'
              },
              series: {
                btnTitle: 'Series de imágenes',
                text: 'Navega fácilmente entre diferentes secuencias, planos (axial, coronal, sagital) o momentos del estudio (con y sin contraste) para un análisis completo y detallado de la anatomía y patología. Esencial para estudios dinámicos y para una visión tridimensional precisa.'
              },
              measurement: {
                btnTitle: 'Medición',
                text: 'Mide distancias, ángulos y áreas con precisión, permitiendo la cuantificación de hallazgos (como el tamaño de nódulos o la extensión de colecciones) y el seguimiento objetivo de los cambios a lo largo del tiempo.'
              },
              contrastControl: {
                btnTitle: 'Control de brillo y contraste',
                text: 'Optimiza la visualización de diferentes tejidos y densidades (como hueso, parénquima pulmonar o estructuras de partes blandas) manipulando el brillo (nivel) y el contraste (ancho de ventana). Esta calibración es crucial para destacar detalles sutiles e identificar lesiones que, de otro modo, pasarían desapercibidas.'
              },
              markersAndAnnotations: {
                btnTitle: 'Anotaciones y marcaciones',
                text: 'Agrega flechas, círculos, textos y otras marcaciones gráficas directamente en las imágenes para destacar áreas de interés, mediciones específicas o hallazgos patológicos. Estas anotaciones son esenciales para el aprendizaje y para orientar a colegas durante la discusión de casos.'
              },
              multiplePanels: {
                btnTitle: 'Múltiples paneles',
                text: 'Permite la organización del área de trabajo para mostrar simultáneamente varias series, cortes o exámenes uno al lado del otro. Esencial para la comparación rápida de diferentes modalidades (ej: TC vs. Resonancia), evaluación bilateral (ej: rodillas) o para visualizar el mismo hallazgo en diferentes planos anatómicos a la vez, optimizando el flujo de trabajo y la correlación de información.'
              }
            }
          },
          footer: {
            text: 'Transforma el estudio de la medicina en un viaje visual. Explora los visualizadores y ve más allá de las imágenes: una nueva forma de aprender.',
            btnText: 'Solicitar presentación'
          }
        },
        appPage: {
          banner: {
            title:
              'BioAtlas App - aprendizaje médico accesible en cualquier lugar',
            text: 'Estudia a través de Contenidos 3D, Láminas de Histología y Exámenes de Radiología usando tu Tablet o Smartphone, organiza tu contenido, crea colecciones y mantén el aprendizaje siempre a tu alcance.'
          },
          visualizer: {
            title: 'Funcionalidades y diferenciales del BioAtlas App',
            items: {
              onlineOffline: {
                btnTitle: 'Acceso online y offline',
                text: 'Accede a los contenidos de BioAtlas en cualquier momento, incluso sin conexión. Descarga los contenidos y continúa tu camino de aprendizaje sin interrupciones.'
              },
              unifiedCollections: {
                btnTitle: 'Colecciones unificadas',
                text: 'Las colecciones creadas en la web pueden ser accedidas en la aplicación BioAtlas y viceversa.'
              },
              contentDiversity: {
                btnTitle: 'Diversidad de contenidos',
                text: 'Explora una vasta biblioteca de contenidos que la App BioAtlas ofrece en la palma de tu mano. Un verdadero hub de aprendizaje médico, reuniendo una diversidad de contenidos sin igual, accesible en cualquier momento y lugar.'
              },
              flashcards: {
                btnTitle: 'Flashcards',
                text: 'Repasa conceptos esenciales, pon a prueba tu memoria y aprende con mayor eficiencia usando los Flashcards de BioAtlas. (próximamente)'
              },
              responsive: {
                btnTitle: 'Responsivo',
                text: 'La navegación en Tablets ofrece una experiencia similar a la de un escritorio. En smartphones, todo el contenido ha sido optimizado, garantizando un acceso rápido y práctico en la palma de la mano.'
              }
            }
          }
        },
        integrationPage: {
          banner: {
            title: 'Integración Institucional',
            subtitle: 'Para instituciones y socios',
            text: 'Transforme su plataforma educativa con el contenido de BioAtlas, acceso simple y rápido y soporte técnico dedicado.',
            btnText: 'Solicitar presentación'
          },
          content: {
            title: 'Integración de contenidos',
            text: 'Conecta BioAtlas al sistema de enseñanza ya utilizado en tu Institución (ej.: Moodle, Canvas) para que los contenidos se publiquen directamente en las asignaturas.',
            imgAlt: 'Integración de contenidos'
          },
          access: {
            title: 'Acceso unificado',
            paragraph1:
              'BioAtlas dispone de recursos para facilitar el acceso a través de su plataforma de enseñanza, facilitando el compromiso de profesores y alumnos con la herramienta.',
            paragraph2:
              'El alumno/profesor puede acceder a BioAtlas a través del portal de su institución sin necesidad de usuario y contraseña, mediante integraciones vía SSO/EZ Proxy.',
            whyTitle: '¿Por qué es útil?',
            whyText:
              'Elimina la necesidad de contraseñas adicionales, reduce las solicitudes de soporte y hace el uso más natural (un {highlight} inicio de sesión para todo).',
            whyTextHighlight: 'único',
            btnText: 'Hablar con el equipo de ventas'
          },
          api: {
            title:
              'Contenido 3D de BioAtlas en su proyecto a través de nuestra API',
            text: 'Construya una experiencia interactiva virtual 3D en su proyecto relacionado con la anatomía u otras disciplinas relacionadas con el ciclo básico en Salud. El contenido de BioAtlas se puede integrar fácilmente en su sitio web, contenido digital, LMS o proyecto digital a través de la API de BioAtlas.'
          },
          institutions: {
            title: 'BioAtlas para su institución',
            items: {
              pharma: 'Farmacéutico',
              university: 'Universidades',
              hospital: 'Hospitales',
              publisher: 'Editores'
            }
          },
          whiteLabel: {
            title: 'BioAtlas con la marca de tu Institución',
            text: 'BioAtlas cuenta con una solución "Private Label", que le permite marcar su Institución, convirtiéndola en una solución 100% personalizada.'
          },
          embed: {
            title: 'Incrustación de contenidos',
            text: 'Incruste los contenidos de BioAtlas (modelos 3D, animaciones, láminas, radiografías) dentro del sitio web, CMS o entorno digital de su Institución. Nuestra documentación técnica detallada y el soporte dedicado están listos para asistir a su equipo de TI durante todo el proceso de implementación, garantizando una integración rápida y exitosa. Transforme la manera en que su institución entrega conocimiento.',
            whyTitle: '¿Por qué es útil?',
            whyText:
              'El estudiante no necesita salir del portal de la universidad para acceder al material, haciendo la experiencia más fluida y profesional.'
          },
          footer: {
            text: 'BioAtlas fue creado para valorizar el tiempo y esfuerzo de los estudiantes, haciendo el aprendizaje más accesible y práctico.',
            btnText: 'Solicitar presentación'
          }
        },
        forTeachers: {
          hero: {
            title: 'Recursos pensados para los profesores.',
            text: 'BioAtlas actúa como un socio de enseñanza, potenciando el trabajo del profesor. La plataforma moderniza la experiencia en el aula y coloca al educador en el centro de la innovación académica.',
            button: 'Solicitar presentación'
          },
          auxiliar: {
            title: 'BioAtlas: Tu Asistente Esencial para Clases',
            tabs: {
              aulasAtrativas: 'Clases más <br/> atractivas',
              ferramentas: 'Herramientas <br/> de presentación',
              colecoes: 'Colecciones <br/> Personalizadas',
              sugestoes: 'Sugerencias <br/> de contenidos'
            },
            imageAlts: {
              aulasAtrativas: 'Clases más atractivas',
              ferramentas: 'Herramientas de presentación',
              colecoes: 'Colecciones Personalizadas',
              sugestoes: 'Sugerencias de contenidos'
            },
            content: {
              aulasAtrativas: {
                p1: 'Optimice la preparación de sus clases y maximice el compromiso de los estudiantes con el acervo interactivo de BioAtlas con miles de contenidos de alta fidelidad y las herramientas de presentación.'
              },
              ferramentas: {
                p1: 'Mejore sus clases con herramientas integradas que permiten la manipulación y personalización inmediata del contenido:',
                b1: '<bold>Interactividad</bold>: Utilice las funciones de corte y selección de elementos en los visualizadores 3D, Lámina y Radiología.',
                b2: '<bold>Enfoque y Colaboración</bold>: Inserte anotaciones y comentarios directamente en las estructuras e imágenes para optimizar la comunicación y dirigir a los participantes.'
              },
              colecoes: {
                p1: 'Con BioAtlas, los profesores tienen la libertad de modificar el contenido 3D para adecuarlo a sus clases. Además, pueden guardar esos cambios en colecciones personales y compartirlas fácilmente con todos los alumnos.'
              },
              sugestoes: {
                p1: 'La colaboración de los profesores es fundamental para mejorar el catálogo de enseñanza de BioAtlas. Los docentes pueden sugerir nuevos contenidos o señalar la ausencia de materiales para enriquecer y complementar sus clases.'
              }
            }
          },
          depoimentos: {
            title:
              'Mira lo que algunos de nuestros usuarios tienen que decir sobre BioAtlas:',
            testimonials: [
              {
                text: '\u201cBioAtlas es una excelente herramienta para que el alumno integre los diferentes contenidos de las ciencias biol\u00f3gicas y de la salud\u201d',
                author: 'Dr. Rodolfo Souza de Faria',
                role: 'Profesor de Fisiolog\u00eda Humana y Neurociencias en FMIT'
              },
              {
                text: '\u201cBioAtlas es una maravillosa plataforma de contenido m\u00e9dico para fortalecer el conocimiento y la pr\u00e1ctica de estudiantes y profesionales m\u00e9dicos.\u201d',
                author:
                  'Dra. Briseida Estefan\u00eda Castill\u00f3n Betancourt',
                role: 'M\u00e9dico Cirujano y Partero - IMSS - M\u00e9xico'
              },
              {
                text: '\u201cBioAtlas es fundamental para la ense\u00f1anza de Anatom\u00eda y de los sistemas fisiol\u00f3gicos, auxiliando mucho en la did\u00e1ctica docente, contribuyendo para la consolidaci\u00f3n de los conocimientos por parte de los alumnos.\u201d',
                author: 'Dra. Ludmila Alem',
                role: 'Prof. de Anatom\u00eda - UFRJ <br /> Prof. de SOI - Medicina Afya | Unigranrio'
              }
            ]
          },
          cta: {
            text: 'BioAtlas ofrece una experiencia de aprendizaje más práctica y accesible.',
            button: 'Solicitar presentación'
          }
        },
        forStudents: {
          hero: {
            title: 'Estudio dinámico para una generación inquieta',
            text: 'Transforme la teoría en práctica, simplifique el aprendizaje y retenga la atención de los estudiantes con BioAtlas. Ponga al estudiante a cargo de su propia trayectoria médica.',
            button: 'Solicitar presentación'
          },
          auxiliar: {
            title:
              'Cómo BioAtlas auxilia la Rutina Académica de los Estudiantes',
            tabs: {
              conexaoProfessores: 'Conexión con <br/> Profesores',
              aprendizadoPratico: 'Aprendizaje <br/> práctico',
              disponivelBolso: 'Disponible en <br/> el bolsillo',
              estudoDinamico: 'Estudio <br/> dinámico'
            },
            imageAlts: {
              conexaoProfessores: 'Conexión con Profesores',
              aprendizadoPratico: 'Aprendizaje prático',
              disponivelBolso: 'Disponible en el bolsillo',
              estudoDinamico: 'Estudio dinámico'
            },
            content: {
              conexaoProfessores: {
                p1: 'Los estudiantes tienen la libertad de acceder a colecciones compartidas por los profesores, revisar el mismo contenido abordado en clase y estudiar de forma clara, a su propio ritmo de aprendizaje.'
              },
              aprendizadoPratico: {
                p1: 'Explore modelos 3D realistas, láminas histológicas digitales y radiología integrada, entendiendo el cuerpo humano en detalles y conexiones.'
              },
              disponivelBolso: {
                p1: 'BioAtlas ofrece acceso flexible en diversos dispositivos, garantizando que los estudiantes puedan consultar sus materiales didácticos en cualquier momento, incluso fuera del entorno académico.'
              },
              estudoDinamico: {
                p1: 'Con colecciones personalizadas y filtros inteligentes, los alumnos pueden seleccionar el contenido que desean revisar y organizar sus temas de estudio favoritos.'
              }
            }
          },
          aprendaInteligente: {
            title:
              'Aprende de forma inteligente, a cualquier hora y en cualquier lugar',
            description:
              'BioAtlas es tu compañero ideal para la rutina de estudios de la salud humana. Hecho para acompañarte en la facultad, en casa o durante los repasos, te permite encontrar el contenido necesario con pocos clics. Repasa para los exámenes y mantén el foco en lo que realmente importa: aprender con claridad.',
            cards: {
              colecoes: {
                title: 'Colecciones, Anotaciones y Marcadores Personalizados',
                description:
                  'Crea un entorno de aprendizaje totalmente personalizado. Utiliza anotaciones y marcadores para registrar observaciones, destacar puntos clave y facilitar el repaso del contenido esencial.'
              },
              flashcards: {
                title: 'Repasa con flashcards',
                description:
                  'Con las flashcards de BioAtlas, repasas conceptos, pones a prueba tus conocimientos y consolidas el contenido de manera ágil y divertida.<br/><br/>Ideal para prepararte antes de los exámenes y mejorar la memoria a largo plazo.'
              },
              modelos: {
                title:
                  'Modelos 3D Interactivos, Exámenes Radiológicos y Láminas de Estudio',
                description:
                  'Explora el cuerpo humano de manera integrada y visual. En BioAtlas, puedes girar, ampliar y comparar modelos anatómicos, observar láminas histológicas digitales y correlacionarlas con imágenes radiológicas reales.'
              }
            }
          },
          depoimentos: {
            title: 'Lo que dicen algunos de nuestros usuarios sobre BioAtlas:',
            testimonials: [
              {
                text: '“Recomendaría sin duda BioAtlas a un amigo o colega porque tiene contenidos que ayudan mucho a los estudiantes a estudiar. Me ayuda en las clases teóricas y prácticas de la Universidad.”',
                author: 'Daniel Martins Vieira',
                role: 'Estudiante Unigranrio'
              },
              {
                text: '“Es genial ver las partes de la anatomía humana de forma interactiva, didáctica y de una forma tener una visión mejorada de cada parte del cuerpo humano muy cercana a la realidad.”',
                author: 'Ana Paula Gomes Peixoto',
                role: 'Afya Facultad de Ciencias Médicas Contagem'
              },
              {
                text: '“BioAtlas está siendo fundamental en este momento de mi trayectoria académica. Material de excelente calidad y fácil manejo, facilitando así la comprensión y el aprendizaje.”',
                author: 'Luciana de Almeida da Cunha',
                role: 'Estudiante de medicina <br /> ULBRA'
              }
            ]
          },
          cta: {
            text: 'BioAtlas fue creado para valorar el tiempo y el esfuerzo del estudiante de medicina.<br/>Aquí, el conocimiento toma forma, el contenido se conecta y el aprendizaje se vuelve más accesible y práctico.',
            button: 'Solicitar presentación'
          }
        },
        facilitySection: {
          sectionTitle: 'Facilidad desde el primer uso',
          features: {
            treinamento: {
              cardTitle: 'Capacitación\nSimplificada',
              title: 'Capacitación Simplificada',
              description:
                'Domine todas las funciones de BioAtlas, desde el primer acceso hasta recursos avanzados de análisis, visualización y gestión. Optimice su flujo de trabalho y maximice el uso de la plataforma.',
              imageAlt: 'Personas en capacitación con pantalla de presentación'
            },
            multiplataforma: {
              cardTitle: 'Acceso\nMultiplataforma',
              title: 'Acceso Multiplataforma',
              description:
                'BioAtlas está disponible para su acceso en cualquier navegador web, además de contar con aplicaciones dedicadas para dispositivos móviles (teléfonos y tabletas) en las plataformas Android e iOS.',
              imageAlt: 'Dispositivos que muestran la plataforma Bioatlas'
            },
            integracao: {
              cardTitle: 'Integración con\nPlataformas Externas',
              title: 'Integración con Plataformas Externas',
              description:
                'Nuestro contenido puede ser incrustado en el sitio web de la Institución Educativa donde trabajas a través de nuestra API.',
              imageAlt:
                'Monitor que muestra la integración con plataformas externas'
            },
            acervo: {
              cardTitle: 'Acervo de Miles\nde Contenidos',
              title: 'Acervo de miles de contenidos',
              description:
                'BioAtlas es una herramienta esencial para la excelencia pedagógica, proporcionando un vasto acervo interactivo con miles de contenidos de alta fidelidad:',
              item1: 'Modelos 3D de Estructuras',
              item2: 'Láminas Histológicas e Histopatológicas Detalladas',
              item3: 'Materiales de Diagnóstico por Imagen',
              imageAlt: 'Interfaz del acervo de contenidos 3D'
            }
          }
        },
        completeAnatomy: {
          hero: {
            title: 'Explore el Cuerpo Humano en detalle',
            text: 'Contenidos que facilitan el aprendizaje de las disciplinas de salud humana a través de la interactividad. Integra las áreas de Ciencias Morfológicas, Ciencias Fisiológicas, Ciencias Humanas y Ciencias Sociales Aplicadas a la Salud.',
            button: 'Solicitar presentación'
          },
          sidebar: {
            title: 'Conozca más sobre los módulos de enseñanza',
            button: 'Solicitar presentación'
          },
          main: {
            title: 'Anatomía Completa',
            paragraph:
              'La Anatomía Humana es la ciencia que estudia la morfología y la organización del cuerpo humano, a través de la observación y el análisis de las estructuras macroscópicas que lo constituyen. Este análisis se correlaciona con el funcionamiento de las distintas partes y los mecanismos de formación y de respuesta a factores ambientales, genéticos y temporales. Puede categorizarse, a partir de la separación de las piezas, en Sistemas Orgánicos y Regiones Anatómicas. En este módulo se contemplaron modelos anatómicos representativos del cuerpo masculino y femenino, además del cadáver virtual masculino.',
            atlas3D: {
              title: 'Atlas Anatómico 3D',
              paragraph:
                'Este módulo cuenta con más de 2500 estructuras identificadas, de acuerdo con la Terminología Anatomica Internacional. Está dividido en modelo Masculino y Femenino y organizado de acuerdo con 12 sistemas anatómicos y 9 regiones.'
            },
            atlasHumano: {
              title: 'Atlas Humano',
              paragraph:
                'El Atlas Humano está constituido por un modelo 3D formado por todos los sistemas anatómicos del cuerpo humano etiquetados y con un sistema de organización avanzado. Desarrollado con la máxima calidad de texturas, el atlas garantiza un conjunto impresionante de datos que pueden utilizarse como referencia durante la discusión de un caso, un plan quirúrgico o una clase de anatomía. Está separado en modelo femenino y masculino, además de poseer un contenido dirigido al estudio de los planos imaginarios que dividen el cuerpo humano. Ellos son:',
              list: {
                female: 'Femenino: 2501 objetos.',
                male: 'Masculino: 2518 objetos.',
                planes: 'Planos Anatómicos: separados en dos colores, siendo:',
                delimitation: 'Planos de delimitación: 7 objetos.',
                section: 'Planos de sección: 5 objetos.'
              }
            },
            cadaver3D: {
              title: 'Cadáver Virtual 3D',
              paragraph:
                'Una versión en 3D de un cuerpo humano real dividido en 1878 rebanadas y fotografiado con equipos de muy alta resolución reconstruídos digitalmente en 3D. El Cadáver Virtual conserva sus colores originales, está segmentado y mapeado para una visualización completa.'
            }
          },
          updates: {
            title: 'Conozca nuestras actualizaciones de contenido de Anatomía',
            olhoHumano: 'Anatomía - Ojo Humano',
            cranio: 'Anatomía - Elementos Descriptivos del Crânio',
            esqueletoAxial:
              'Anatomía - Elementos Descriptivos del Esqueleto Axial'
          }
        },
        systemicAnatomy: {
          hero: {
            title: 'Explore el Cuerpo Humano en detalles',
            text: 'Contenidos que facilitan el aprendizaje de las disciplinas de salud humana a través de la interactividad. Integra las áreas de Ciencias Morfológicas, Ciencias Fisiológicas, Ciencias Humanas y Ciencias Sociales Aplicadas a la Salud.',
            button: 'Solicitar presentación'
          },
          sidebar: {
            title: 'Conozca más sobre los módulos de enseñanza',
            button: 'Solicitar presentación'
          },
          main: {
            title: 'Anatomía Sistémica',
            paragraph:
              'La Anatomía Sistémica trata del estudio analítico de los sistemas orgánicos del cuerpo humano, estableciendo conjuntos de órganos y piezas anatómicas que realizan, de manera integrada, las mismos funciones en los mecanismos biológicos. Aunque cada sistema realiza una tarea diferente, todos están interconectados, garantizando el funcionamiento y la supervivencia del organismo en su conjunto. En este módulo se consideran los siguientes sistemas:',
            list: {
              arterial: 'Arterial Femenino y Masculino,',
              articular: 'Articular,',
              digestorio: 'Digestivo Femenino y Masculino,',
              endocrino: 'Endocrino,',
              esqueletico: 'Esquelético,',
              linfatico: 'Linfático,',
              muscular: 'Muscular,',
              nervoso: 'Nervioso Femenino y Masculino,',
              respiratorio: 'Respiratorio,',
              tegumentar: 'Tegumentario Femenino y Masculino, ,',
              urogenital: 'Urogenital Femenino y Masculino,',
              venoso: 'Venoso Femenino y Masculino.'
            }
          },
          updates: {
            title: 'Conozca nuestras actualizaciones de contenido de Anatomía',
            digestorio:
              'NOVEDAD - Actualización del Sistema Digestivo Femenino',
            rinsBexiga: 'NOVEDAD - Mejoras en los modelos de riñones y vejiga',
            pulmao: 'NOVEDAD - Mejoras en el modelo de pulmón'
          }
        },
        topographicAnatomy: {
          hero: {
            title: 'Explore el Cuerpo Humano en detalles',
            text: 'Contenidos que facilitan el aprendizaje de las disciplinas de salud humana a través de la interactividad. Integra las áreas de Ciencias Morfológicas, Ciencias Fisiológicas, Ciencias Humanas y Ciencias Sociales Aplicadas a la Salud.',
            button: 'Solicitar presentación'
          },
          sidebar: {
            title: 'Conozca más sobre los módulos de enseñanza',
            button: 'Solicitar presentación'
          },
          main: {
            title: 'Anatomía Topográfica',
            paragraph:
              'La Anatomía Topográfica trata del estudio de la división del cuerpo humano en regiones, con el fin de facilitar la comprensión de las relaciones anatómicas entre las estructuras de todos los sistemas en un segmento determinado del cuerpo. Este método ayuda a dominar la topografía general de los órganos a partir de la percepción del funcionamiento y la ubicación de todas las piezas cercanas y relacionadas. En este módulo se incluyen las siguientes regiones anatómicas: Elementos Descriptivos del Cráneo, cabeza y cuello, miembro superior derecho, miembro superior izquierdo, dorso, tórax, abdomen, pelvis, miembro inferior derecho y miembro inferior izquierdo.'
          },
          updates: {
            title: 'Conozca nuestras actualizaciones de contenido de Anatomía',
            ossosLongos: 'Anatomía - Anatomía Interna de los Huesos Largos',
            rinsBexiga: 'NOVEDAD - Mejoras en los modelos de riñones y vejiga',
            pulmao: 'NOVEDAD - Mejoras en el modelo de pulmón'
          }
        },
        cytology: {
          hero: {
            title: 'Explore el Cuerpo Humano en detalles',
            text: 'Contenidos que facilitan el aprendizaje de las disciplinas de salud humana a través de la interactividad. Integra las áreas de Ciencias Morfológicas, Ciencias Fisiológicas, Ciencias Humanas y Ciencias Sociales Aplicadas a la Salud.',
            button: 'Solicitar presentación'
          },
          sidebar: {
            title: 'Conozca más sobre los módulos de enseñanza',
            button: 'Solicitar presentación'
          },
          main: {
            title: 'Citología',
            paragraph:
              'El módulo de Citología permite al usuario interactuar con dos categorías de contenidos 3D: Células y Membrana Celular. Explore las estructuras celulares en detalle, con interactividad de vanguardia. Navegue por las células: Célula Eucariota de origen animal, Célula Sanguínea, Neurona y Fibra Muscular. Visualice un modelo de Membrana Celular en 3D y animaciones relacionadas con el transporte de moléculas a través de la membrana.'
          },
          updates: {
            title: 'Conozca nuestras actualizaciones de Citología',
            celulaNervosa: 'Citología - Célula Nervosa',
            celulasSanguineas: 'Citología - Células Sanguíneas',
            sistemaImunologico: 'Citología - Células del Sistema Inmunológico'
          }
        },
        biochemistry: {
          hero: {
            title: 'Explore el Cuerpo Humano en detalles',
            text: 'Contenidos que facilitan el aprendizaje de las disciplinas de salud humana a través de la interactividad. Integra las áreas de Ciencias Morfológicas, Ciencias Fisiológicas, Ciencias Humanas y Ciencias Sociales Aplicadas a la Salud.',
            button: 'Solicitar presentación'
          },
          sidebar: {
            title: 'Conozca más sobre los módulos de enseñanza',
            button: 'Solicitar presentación'
          },
          main: {
            title: 'Bioquímica',
            paragraph:
              'La Bioquímica estudia los procesos moleculares en los seres vivos, siendo esencial para comprender la salud y el origen de las enfermedades. Al estudiar biomoléculas — como proteínas, lípidos, carbohidratos y ácidos nucleicos — y las complejas vías metabólicas que regulan el funcionamiento celular, permite interpretar el organismo en su nivel más fundamental. Este conocimiento es decisivo no solo para entender la base de procesos fisiológicos y patológicos, sino también para el desarrollo de terapias, diagnósticos y tecnologías aplicadas a la salud. De esta forma, la Bioquímica amplía la capacidad de investigación científica y promueve una visión integrada sobre el cuerpo.',
            bullet1: 'Estructura de los Aminoácidos;',
            bullet2: 'Estructura Secundaria de las Proteínas;',
            bullet3: 'Tipos de Carbohidratos;',
            bullet4: 'Estructura Terciaria y Cuaternaria de las Proteínas;',
            bullet5: 'Acción de las Enzimas;',
            bullet6: 'Señalización de la Membrana Celular;',
            bullet7: 'Glicólisis;',
            bullet8: 'Ciclo del Ácido Cítrico;',
            bullet9: 'Fosforilación Oxidativa;',
            bullet10: 'Gluconeogénesis;',
            bullet11: 'Catabolismo de los Aminoácidos;',
            bullet12: 'Vía de las Pentosas Fosfato;',
            bullet13: 'Ciclo de la Ureia;',
            bullet14: 'Glicogénesis;',
            bullet15: 'Radicales Libres.'
          },
          updates: {
            title: 'Descubra nuestras actualizaciones de Bioquímica',
            celulaNervosa: 'Bioquímica - Célula Nervosa',
            celulasSanguineas: 'Bioquímica - Células Sanguíneas',
            sistemaImunologico: 'Bioquímica - Células do Sistema Imunológico'
          }
        },
        physiology: {
          hero: {
            title: 'Explore el Cuerpo Humano en detalles',
            text: 'Contenidos que facilitan el aprendizaje de las disciplinas de salud humana a través de la interactividad. Integra las áreas de Ciencias Morfológicas, Ciencias Fisiológicas, Ciencias Humanas y Ciencias Sociales Aplicadas a la Salud.',
            button: 'Solicitar presentación'
          },
          sidebar: {
            title: 'Conozca más sobre los modelos de enseñanza',
            button: 'Solicitar presentación'
          },
          main: {
            title: 'Fisiología',
            paragraph:
              'Explore el funcionamiento y las funciones normales del cuerpo humano, a través de contenidos virtuales 3D interactivos:',
            bullet1: 'Anticuerpos: clases y funciones',
            bullet2: 'Ciclo cardíaco del corazón',
            bullet3: 'Circulación pulmonar y sistémica',
            bullet4: 'Contracción de la fibra muscular',
            bullet5: 'Generación y conducción del potencial de acción',
            bullet6: 'Hematosis pulmonar',
            bullet7: 'Mecanismo de retroalimentación',
            bullet8: 'Transmisión sináptica',
            bullet9: 'Ventilación pulmonar'
          },
          updates: {
            title: 'Conozca nuestras actualizaciones de Fisiología',
            hematosePulmonar: 'Fisiología - Hematosis pulmonar',
            controleHiperglicemiaInsulina:
              'Fisiología - Control de la Hiperglucemia Insulina',
            transmissaoSinaptica: 'Fisiología - Transmisión Sináptica'
          }
        },
        histology: {
          hero: {
            title: 'Explore el Cuerpo Humano en detalles',
            text: 'Contenidos que facilitan el aprendizaje de las disciplinas de salud humana a través de la interactividad. Integra las áreas de Ciencias Morfológicas, Ciencias Fisiológicas, Ciencias Humanas y Ciencias Sociales Aplicadas a la Salud.',
            button: 'Solicitar presentación'
          },
          sidebar: {
            title: 'Conozca más sobre los módulos de análisis',
            button: 'Solicitar presentación'
          },
          main: {
            title: 'Histología',
            paragraph:
              'BioAtlas cuenta con un módulo dedicado al estudio de láminas con cientos de ejemplos de glándulas, órganos, tejidos y sistemas, y láminas con patologías. Además, cuenta con una herramienta con recursos para la visualización y análisis de las mismas con zoom de hasta 40x, marcado en láminas, espejo, etc.'
          },
          updates: {
            title: 'Conozca nuestras actualizaciones de Histología',
            novasLaminasDescritivos:
              'NOVEDAD - Textos descriptivos en todas las láminas histológicas',
            patologiaHistopatologia: 'Patología - Histopatología',
            histopatologiaNovasLaminas: 'HISTOPATOLOGÍA - Nuevas Láminas'
          }
        },
        histopathology: {
          hero: {
            title: 'Explore el Cuerpo Humano en detalles',
            text: 'Contenidos que facilitan el aprendizaje de las disciplinas de salud humana a través de la interactividad. Integra las áreas de Ciencias Morfológicas, Ciencias Fisiológicas, Ciencias Humanas y Ciencias Sociales Aplicadas a la Salud.',
            button: 'Solicitar presentación'
          },
          sidebar: {
            title: 'Conozca más sobre los módulos de enseñanza',
            button: 'Solicitar presentación'
          },
          main: {
            title: 'Histopatología',
            paragraph:
              'Esta categoría cuenta con cientos de láminas histológicas que muestran patologías en tejidos y células de diversos sistemas y regiones anatómicas del cuerpo humano.',
            bullet1: 'Enfermedades del sistema respiratorio',
            bullet2: 'Enfermedades del sistema cardiovascular',
            bullet3: 'Enfermedades del sistema digestivo',
            bullet4: 'Trastornos de la circulación sanguínea',
            bullet5: 'Tumor',
            bullet6: 'Enfermedades del sistema nervioso',
            bullet7: 'Enfermedades del sistema genital',
            bullet8: 'Enfermedades del sistema urogenital',
            bullet9: 'Inflamación',
            bullet10: 'Lesión y reparación de células y tejidos',
            bullet11: 'Enfermedades del sistema endocrino',
            bullet12: 'Enfermedades inmunológicas',
            bullet13: 'Enfermedades de los sistemas muscular y esquelético',
            bullet14: 'Enfermedades del sistema hematopoyético'
          },
          updates: {
            title: 'Conozca nuestras actualizaciones de Histopatología',
            novidadeModuloHistopatologia: 'NOVEDAD - Módulo de Histopatología',
            novosTextosTumor: 'Nuevos textos descriptivos Histopatología Tumor',
            histopatologiaNovasLaminas: 'HISTOPATOLOGÍA - Nuevas Láminas'
          }
        },
        embryology: {
          hero: {
            title: 'Explore el Cuerpo Humano en detalles',
            text: 'Contenidos que facilitan el aprendizaje de las disciplinas de salud humana a través de la interactividad. Integra las áreas de Ciencias Morfológicas, Ciencias Fisiológicas, Ciencias Humanas y Ciencias Sociales Aplicadas a la Salud.',
            button: 'Solicitar presentación'
          },
          sidebar: {
            title: 'Conozca más sobre los módulos de enseñanza',
            button: 'Solicitar presentación'
          },
          main: {
            title: 'Embriología',
            paragraph:
              'Este módulo ofrece una visión tridimensional del desarrollo humano, desde la zigogénesis, el desarrollo embrionario y fetal, la placenta y las membranas fetales con el más alto nivel de detalle. La interactividad de vanguardia, combinada con el acceso en línea, se convierte en un diferenciador único en el estudio del desarrollo.'
          },
          updates: {
            title:
              'Conozca nuestras actualizaciones de contenido de Embriología',
            placentaDetalhes: 'Embriología - Placenta en Detalle',
            gestaoGemelar: 'Embriología - Gestación Gemelar',
            visaoGeral: 'Embriología - Visión General'
          }
        },
        radiology: {
          hero: {
            title: 'Explore el Cuerpo Humano en detalles',
            text: 'Contenidos que facilitan el aprendizaje de las disciplinas de salud humana a través de la interactividad. Integra las áreas de Ciencias Morfológicas, Ciencias Fisiológicas, Ciencias Humanas y Ciencias Sociales Aplicadas a la Salud.',
            button: 'Solicitar presentación'
          },
          sidebar: {
            title: 'Conozca más sobre los módulos de enseñanza',
            button: 'Solicitar presentación'
          },
          main: {
            title: 'Radiología',
            paragraph:
              'El módulo de Radiología de BioAtlas permite al usuario explorar imágenes diagnósticas de alta calidad integradas con modelos 3D del cuerpo humano. Desarrollado para facilitar la comprensión de las estructuras anatómicas desde la perspectiva radiológica, el módulo contempla diferentes modalidades de imagen, como rayos X, tomografía y resonancia magnética, asociadas a las estructuras 3D correspondientes.'
          },
          updates: {
            title:
              'Conozca nuestras actualizaciones de contenido de Radiología',
            update1: 'Radiología - Cráneo y Elementos Descriptivos',
            update2: 'Radiología - Ojo Humano',
            update3: 'Radiología - Huesos Largos'
          }
        },
        pathology: {
          hero: {
            title: 'Explore el Cuerpo Humano en detalles',
            text: 'Contenidos que facilitan el aprendizaje de las disciplinas de salud humana a través de la interactividad. Integra las áreas de Ciencias Morfológicas, Ciencias Fisiológicas, Ciencias Humanas y Ciencias Sociales Aplicadas a la Salud.',
            button: 'Solicitar demostración'
          },
          sidebar: {
            title: 'Conozca más sobre los módulos de enseñanza',
            button: 'Solicitar presentación'
          },
          main: {
            title: 'Patología',
            paragraph:
              'La patología es la ciencia que estudia los cambios estructurales, bioquímicos y funcionales en células, tejidos y órganos que subyacen a las enfermedades. A partir del estudio de la etiología (causas), patogénesis (mecanismos de desarrollo), alteraciones morfológicas (cambios estructurales en células y órganos) y fisiopatología (consecuencias funcionales de los cambios morfológicos), busca comprender el funcionamiento del organismo en los procesos de salud y enfermedad.',
            section1Title: 'Condiciones patológicas',
            section2Title: 'Patología general',
            bullet1_1: 'Acné',
            bullet1_2: 'Afecciones pleurales',
            bullet1_3: 'Anemia falciforme',
            bullet1_4: 'Asma',
            bullet1_5: 'Cardiopatía isquêmica',
            bullet1_6: 'Desviaciones de la columna vertebral',
            bullet1_7: 'Diabetes mellitus tipo 1',
            bullet1_8: 'Diabetes mellitus tipo 2',
            bullet1_9: 'Distensión muscular',
            bullet1_10: 'Enfermedad de Graves',
            bullet1_11: 'Enfermedad ulcerosa péptica',
            bullet1_12: 'Gastritis',
            bullet1_13: 'Fracturas óseas',
            bullet1_14: 'Neumonía',
            bullet1_15: 'Síndrome de ovario poliquístico',
            bullet1_16: 'Sinusitis',
            bullet1_17: 'Tiroiditis de Hashimoto',
            bullet1_18: 'Trombosis',
            bullet1_19: 'Tromboembolismo pulmonar',
            bullet1_20: 'Tuberculosis',
            bullet1_21: 'Urticaria',
            bullet2_1: 'Adaptación celular',
            bullet2_2: 'Adaptación tisular',
            bullet2_3: 'Muerte celular (necrosis)',
            bullet2_4: 'Lesiones reversibles o irreversibles',
            bullet2_5: 'Acumulación intracelular (esteatosis)',
            bullet2_6: 'Reparación tisular',
            bullet2_7: 'Trastorno hemodinámico - inflamación',
            bullet2_8: 'Trastorno del crecimiento',
            bullet2_9: 'Alteraciones circulatorias - hiperemia/congestión',
            bullet2_10: 'Alteraciones circulatorias - isquemia/infarto',
            bullet2_11: 'Calcificación patológica',
            bullet2_12: 'Neoplasia'
          },
          updates: {
            title: 'Conozca nuestras actualizaciones de Patología',
            update1: 'Patología - Tromboembolismo pulmonar',
            update2: 'Patología - Acné',
            update3: 'Patología - Gastritis'
          }
        }
      }
    }
  }
}

export { messages }
